export const IconConfig = {
  Shield: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7134 3.35001C17.7046 3.21039 17.6491 3.07777 17.556 2.97338C17.4629 2.86899 17.3374 2.79886 17.1997 2.77422C13.8208 2.16797 12.4103 1.72969 9.25713 0.305475C9.17624 0.268911 9.08848 0.25 8.99971 0.25C8.91094 0.25 8.82318 0.268911 8.74229 0.305475C5.58916 1.72969 4.17862 2.16797 0.799711 2.77422C0.662004 2.79886 0.536544 2.86899 0.443414 2.97338C0.350284 3.07777 0.294869 3.21039 0.28604 3.35001C0.135649 5.73711 0.456352 7.96133 1.24034 9.96094C1.88234 11.592 2.83245 13.0841 4.03877 14.3559C6.12745 16.5719 8.34502 17.5344 8.76807 17.7047C8.9184 17.7655 9.08649 17.7655 9.23682 17.7047C9.65987 17.5344 11.8774 16.5719 13.9661 14.3559C15.1705 13.0837 16.1187 11.5916 16.7591 9.96094C17.5431 7.96133 17.8638 5.73711 17.7134 3.35001ZM12.5962 6.28399L8.26807 11.284C8.21242 11.3485 8.14417 11.4009 8.06753 11.438C7.99089 11.4752 7.90746 11.4963 7.82237 11.5H7.79659C7.63301 11.5 7.47594 11.436 7.35909 11.3215L5.43721 9.43868C5.37858 9.38122 5.33183 9.31278 5.29965 9.23727C5.26747 9.16175 5.25047 9.08063 5.24964 8.99855C5.24795 8.83277 5.31219 8.67311 5.42823 8.55469C5.54426 8.43628 5.70258 8.36881 5.86836 8.36712C6.03414 8.36544 6.1938 8.42968 6.31221 8.54571L7.75752 9.96329L11.6521 5.46602C11.7058 5.40395 11.7712 5.35307 11.8445 5.31628C11.9179 5.27948 11.9978 5.2575 12.0797 5.25159C12.1616 5.24568 12.2438 5.25595 12.3217 5.28182C12.3996 5.30768 12.4716 5.34864 12.5337 5.40235C12.5958 5.45606 12.6466 5.52147 12.6834 5.59484C12.7202 5.66821 12.7422 5.74811 12.7481 5.82998C12.754 5.91185 12.7438 5.99408 12.7179 6.07198C12.692 6.14988 12.6511 6.22192 12.5974 6.28399H12.5962Z"
        fill="currentColor"
      />
    </svg>
  ),
  ListFilled: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00024 11.834H22"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.83373 12.6675C3.29418 12.6675 3.66746 12.2942 3.66746 11.8337C3.66746 11.3733 3.29418 11 2.83373 11C2.37327 11 2 11.3733 2 11.8337C2 12.2942 2.37327 12.6675 2.83373 12.6675Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.00024 3.29999H22"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.83373 4.16746C3.29418 4.16746 3.66746 3.79418 3.66746 3.33373C3.66746 2.87327 3.29418 2.5 2.83373 2.5C2.37327 2.5 2 2.87327 2 3.33373C2 3.79418 2.37327 4.16746 2.83373 4.16746Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.00024 20.834H22"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.83373 21.6675C3.29418 21.6675 3.66746 21.2942 3.66746 20.8337C3.66746 20.3733 3.29418 20 2.83373 20C2.37327 20 2 20.3733 2 20.8337C2 21.2942 2.37327 21.6675 2.83373 21.6675Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Repeat: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6385 5.06411C15.3197 4.74531 14.8028 4.74531 14.484 5.06411C14.1652 5.3829 14.1652 5.89977 14.484 6.21857L15.3864 7.12088L6.64286 7.12088L6.64042 7.12089C5.41083 7.12456 4.23266 7.61464 3.36321 8.48409C2.49375 9.35354 2.00368 10.5317 2 11.7613V11.7637V12.529C2 12.9799 2.36548 13.3454 2.81633 13.3454C3.26717 13.3454 3.63265 12.9799 3.63265 12.529V11.765C3.63534 10.9672 3.95347 10.2027 4.51767 9.63855C5.08186 9.07436 5.84629 8.75622 6.64415 8.75354H11.0153H15.3865L14.484 9.65595C14.1652 9.97474 14.1652 10.4916 14.484 10.8104C14.8028 11.1292 15.3197 11.1292 15.6385 10.8104L17.9344 8.51449C18.2532 8.19569 18.2532 7.67882 17.9344 7.36003L15.6385 5.06411ZM9.51601 13.4824C9.8348 13.8012 9.8348 14.3181 9.51601 14.6369L8.61364 15.5393H17.3559C18.1537 15.5366 18.9181 15.2184 19.4823 14.6542C20.0465 14.0901 20.3646 13.3257 20.3673 12.5278V11.7637C20.3673 11.3129 20.7328 10.9474 21.1837 10.9474C21.6345 10.9474 22 11.3129 22 11.7637V12.529L22 12.5315C21.9963 13.7611 21.5062 14.9392 20.6368 15.8087C19.7673 16.6781 18.5892 17.1682 17.3596 17.1719L17.3571 17.1719H8.61364L9.51601 18.0743C9.8348 18.3931 9.8348 18.9099 9.51601 19.2287C9.19721 19.5475 8.68034 19.5475 8.36155 19.2287L6.06563 16.9328C5.74683 16.614 5.74683 16.0971 6.06563 15.7783L8.36155 13.4824C8.68034 13.1636 9.19721 13.1636 9.51601 13.4824Z"
        fill="currentColor"
      />
    </svg>
  ),
  RepeatOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 11.6667V12.5C21.9967 13.604 21.5567 14.6619 20.776 15.4426C19.9953 16.2233 18.9374 16.6634 17.8333 16.6667H7H6M6 16.6667L9 13.5M6 16.6667L9 19.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 7.5H6.16667C5.06261 7.5033 4.00472 7.94334 3.22403 8.72403C2.44334 9.50472 2.0033 10.5626 2 11.6667V12.5M17 7.5L14.5 5M17 7.5L14.5 10"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  TrustedDealer: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4565 5.22001C22.446 5.05247 22.3795 4.89333 22.2677 4.76806C22.1559 4.64279 22.0054 4.55864 21.8401 4.52907C17.7855 3.80157 16.0928 3.27563 12.309 1.56657C12.212 1.52269 12.1067 1.5 12.0001 1.5C11.8936 1.5 11.7883 1.52269 11.6912 1.56657C7.90749 3.27563 6.21483 3.80157 2.16014 4.52907C1.99489 4.55864 1.84434 4.64279 1.73259 4.76806C1.62083 4.89333 1.55433 5.05247 1.54374 5.22001C1.36327 8.08454 1.74811 10.7536 2.68889 13.1531C3.45929 15.1104 4.59943 16.901 6.04702 18.427C8.55342 21.0863 11.2145 22.2413 11.7222 22.4456C11.9026 22.5186 12.1043 22.5186 12.2847 22.4456C12.7923 22.2413 15.4534 21.0863 17.9598 18.427C19.4051 16.9004 20.543 15.1099 21.3114 13.1531C22.2522 10.7536 22.637 8.08454 22.4565 5.22001ZM16.3159 8.74079L11.1222 14.7408C11.0554 14.8182 10.9735 14.8811 10.8815 14.9256C10.7896 14.9702 10.6894 14.9955 10.5873 15H10.5564C10.3601 15.0001 10.1716 14.9231 10.0314 14.7858L7.72514 12.5264C7.65478 12.4575 7.59869 12.3753 7.56007 12.2847C7.52145 12.1941 7.50106 12.0968 7.50006 11.9983C7.49803 11.7993 7.57512 11.6077 7.71436 11.4656C7.8536 11.3235 8.04358 11.2426 8.24252 11.2405C8.44145 11.2385 8.63304 11.3156 8.77514 11.4549L10.5095 13.1559L15.183 7.75923C15.2474 7.68474 15.3259 7.62368 15.4139 7.57953C15.502 7.53538 15.5979 7.50901 15.6961 7.50191C15.7944 7.49481 15.893 7.50714 15.9865 7.53818C16.08 7.56922 16.1664 7.61837 16.2409 7.68282C16.3154 7.74727 16.3765 7.82576 16.4206 7.91381C16.4648 8.00186 16.4911 8.09774 16.4982 8.19598C16.5053 8.29422 16.493 8.3929 16.462 8.48638C16.4309 8.57985 16.3818 8.6663 16.3173 8.74079H16.3159Z"
        fill="currentColor"
      />
    </svg>
  ),
  ListOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5702 16.887L10.5792 18.4233C8.7161 19.8608 6.04042 19.5158 4.60289 17.6528C3.16535 15.7897 3.51032 13.114 5.3734 11.6765L7.32049 10.1741"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4737 7.10521L13.4208 5.60285C15.2839 4.16532 17.9596 4.51029 19.3971 6.37337C20.8346 8.23645 20.4897 10.9121 18.6266 12.3497L16.6356 13.8859"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.91004 14.3701L15.0897 9.60194"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Accessibility: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1875 6.37504C11.7549 6.37504 11.3319 6.24674 10.9722 6.00637C10.6125 5.76601 10.3321 5.42436 10.1665 5.02465C10.0009 4.62493 9.95763 4.18509 10.042 3.76076C10.1264 3.33642 10.3348 2.94664 10.6407 2.64071C10.9466 2.33478 11.3364 2.12644 11.7608 2.04203C12.1851 1.95763 12.6249 2.00095 13.0246 2.16652C13.4244 2.33208 13.766 2.61246 14.0064 2.9722C14.2467 3.33193 14.375 3.75487 14.375 4.18752C14.3744 4.76749 14.1437 5.32354 13.7336 5.73364C13.3235 6.14375 12.7675 6.37442 12.1875 6.37504Z"
        fill="currentColor"
      />
      <path
        d="M18.9997 6.40607L18.9822 6.41076L18.9657 6.41584C18.9267 6.42678 18.8876 6.4385 18.8486 6.4506C18.1216 6.66389 14.5934 7.65843 12.1079 7.65843C9.79809 7.65843 6.58908 6.79904 5.56251 6.50725C5.46034 6.46774 5.35601 6.43409 5.25001 6.40646C4.50782 6.21115 4 6.96506 4 7.65413C4 8.33656 4.61329 8.66156 5.23243 8.89476V8.9057L8.95199 10.0674C9.33207 10.2131 9.43364 10.362 9.48325 10.4909C9.64458 10.9045 9.51567 11.7237 9.46997 12.0096L9.2434 13.7675L7.98597 20.6499C7.98206 20.6687 7.97855 20.6878 7.97542 20.7074L7.96644 20.757C7.87581 21.3878 8.3391 21.9999 9.21645 21.9999C9.98208 21.9999 10.32 21.4714 10.4665 20.7523C10.6129 20.0331 11.5602 14.5972 12.1071 14.5972C12.654 14.5972 13.7805 20.7523 13.7805 20.7523C13.927 21.4714 14.2649 21.9999 15.0306 21.9999C15.9103 21.9999 16.3735 21.3851 16.2806 20.7523C16.2726 20.6991 16.2627 20.6462 16.2509 20.5937L14.9763 13.7682L14.7501 12.0104C14.5864 10.9866 14.7181 10.6483 14.7626 10.569C14.7638 10.5671 14.7648 10.5652 14.7657 10.5631C14.8079 10.485 15.0001 10.31 15.4485 10.1416L18.9361 8.9225C18.9575 8.91679 18.9786 8.91002 18.9993 8.90219C19.6243 8.66781 20.2493 8.34359 20.2493 7.65491C20.2493 6.96623 19.7419 6.21115 18.9997 6.40607Z"
        fill="currentColor"
      />
    </svg>
  ),
  AccessibilityOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0001 5.33328C12.9206 5.33328 13.6668 4.5871 13.6668 3.66664C13.6668 2.74618 12.9206 2 12.0001 2C11.0797 2 10.3335 2.74618 10.3335 3.66664C10.3335 4.5871 11.0797 5.33328 12.0001 5.33328Z"
        stroke="currentColor"
        strokeWidth="1.59997"
        strokeLinejoin="round"
      />
      <path
        d="M9.84333 12.7684C9.96416 12.0159 10.0183 11.2884 9.82249 10.7855C9.65583 10.353 9.29334 10.111 8.85584 9.94596L5.00049 8.69848C4.5005 8.53182 4.03343 8.25266 4.00051 7.701C3.95884 6.99268 4.58383 6.53436 5.20882 6.70102C5.20882 6.70102 8.87543 7.9985 12.0004 7.9985C15.1253 7.9985 18.7503 6.70685 18.7503 6.70685C19.5002 6.49852 20.0002 7.08185 20.0002 7.69809C20.0002 8.29016 19.5419 8.49849 19.0003 8.69557L15.3337 10.0251C15.0003 10.1501 14.4587 10.4001 14.2503 10.7826C14.0003 11.2305 14.042 12.013 14.1628 12.7655L14.4087 14.0001L15.9674 20.8291C16.0841 21.377 15.7049 21.8891 15.1591 21.9849C14.6132 22.0808 14.167 21.7083 14.0053 21.1783L12.4404 16.3479C12.3651 16.1163 12.2984 15.882 12.2404 15.645L12.0004 14.6667L11.7795 15.5688C11.7095 15.8563 11.629 16.1407 11.5379 16.4221L10.0004 21.1741C9.83374 21.7095 9.39625 22.0803 8.85043 21.9849C8.3046 21.8895 7.91711 21.3354 8.03961 20.8291L9.5975 14.003L9.84333 12.7684Z"
        stroke="currentColor"
        strokeWidth="1.59997"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Add: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 2.00006C12.4092 2.00006 12.7408 2.3317 12.7408 2.7408V11.2593H21.2593C21.6684 11.2593 22.0001 11.591 22.0001 12.0001C22.0001 12.4092 21.6684 12.7408 21.2593 12.7408H12.7408V21.2593C12.7408 21.6684 12.4092 22.0001 12.0001 22.0001C11.591 22.0001 11.2593 21.6684 11.2593 21.2593V12.7408H2.7408C2.3317 12.7408 2.00006 12.4092 2.00006 12.0001C2.00006 11.591 2.3317 11.2593 2.7408 11.2593H11.2593V2.7408C11.2593 2.3317 11.591 2.00006 12.0001 2.00006Z"
        fill="currentColor"
      />
    </svg>
  ),
  AddCircle: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48606 2 2 6.48606 2 12C2 17.5139 6.48606 22 12 22C17.5139 22 22 17.5139 22 12C22 6.48606 17.5139 2 12 2ZM15.8462 12.7692H12.7692V15.8462C12.7692 16.0502 12.6882 16.2458 12.5439 16.3901C12.3997 16.5343 12.204 16.6154 12 16.6154C11.796 16.6154 11.6003 16.5343 11.4561 16.3901C11.3118 16.2458 11.2308 16.0502 11.2308 15.8462V12.7692H8.15385C7.94983 12.7692 7.75418 12.6882 7.60992 12.5439C7.46566 12.3997 7.38462 12.204 7.38462 12C7.38462 11.796 7.46566 11.6003 7.60992 11.4561C7.75418 11.3118 7.94983 11.2308 8.15385 11.2308H11.2308V8.15385C11.2308 7.94983 11.3118 7.75418 11.4561 7.60992C11.6003 7.46566 11.796 7.38462 12 7.38462C12.204 7.38462 12.3997 7.46566 12.5439 7.60992C12.6882 7.75418 12.7692 7.94983 12.7692 8.15385V11.2308H15.8462C16.0502 11.2308 16.2458 11.3118 16.3901 11.4561C16.5343 11.6003 16.6154 11.796 16.6154 12C16.6154 12.204 16.5343 12.3997 16.3901 12.5439C16.2458 12.6882 16.0502 12.7692 15.8462 12.7692Z"
        fill="currentColor"
      />
    </svg>
  ),
  AddCircleOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12C22 6.47917 17.5208 2 12 2C6.47917 2 2 6.47917 2 12C2 17.5208 6.47917 22 12 22C17.5208 22 22 17.5208 22 12Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M16.1666 12.0003H7.83325M11.9999 7.83362V16.167V7.83362Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  AddOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12H2M12 2V22V2Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Airplane: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.10889 22H7.9997C7.88825 22 7.77859 21.9677 7.68074 21.9061C7.58289 21.8445 7.49998 21.7557 7.43959 21.6476C7.3792 21.5395 7.34326 21.4157 7.33505 21.2874C7.32684 21.1592 7.34663 21.0306 7.3926 20.9135L10.0785 14.0745L6.04549 13.9712L4.57463 16.0274C4.2942 16.4341 4.07045 16.6154 3.4996 16.6154H2.75292C2.6347 16.6198 2.5173 16.5912 2.41068 16.5321C2.30405 16.473 2.21134 16.3852 2.14041 16.276C2.04124 16.1216 1.94374 15.8601 2.03874 15.487L2.86459 12.0736C2.87084 12.0481 2.87834 12.0226 2.88667 11.9976C2.88709 11.9952 2.88709 11.9928 2.88667 11.9904C2.87807 11.9654 2.8707 11.9399 2.86459 11.9139L2.03791 8.47885C1.94832 8.11298 2.04624 7.85721 2.14457 7.70673C2.21061 7.60563 2.29628 7.52382 2.3947 7.46788C2.49312 7.41193 2.60154 7.38342 2.71125 7.38462H3.4996C3.92586 7.38462 4.33962 7.60529 4.58296 7.96154L6.02341 9.98317L10.0785 9.91394L7.39344 3.08702C7.3474 2.96993 7.32754 2.84139 7.33566 2.71316C7.34378 2.58492 7.37963 2.46108 7.43994 2.35296C7.50024 2.24484 7.58307 2.15588 7.68086 2.09422C7.77864 2.03256 7.88826 2.00017 7.9997 2H9.12097C9.2774 2.00363 9.43112 2.04787 9.5707 2.12943C9.71028 2.211 9.83214 2.3278 9.92724 2.47115L15.1378 9.77885L17.5449 9.70577C17.7212 9.69471 18.2095 9.69087 18.3224 9.69087C20.625 9.69231 22 10.5548 22 12C22 12.4548 21.8425 13.2981 20.7887 13.8346C20.1666 14.1519 19.3366 14.3125 18.3216 14.3125C18.2099 14.3125 17.7228 14.3087 17.5441 14.2976L15.1374 14.2236L9.91391 21.5312C9.81873 21.674 9.69697 21.7902 9.55764 21.8713C9.4183 21.9525 9.26494 21.9964 9.10889 22Z"
        fill="currentColor"
      />
    </svg>
  ),
  AirplaneOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7732 10.3333C18.6214 10.3333 18.113 10.3385 17.9697 10.349L15.0724 10.4375C15.0573 10.4386 15.0423 10.4348 15.029 10.4265C15.0156 10.4182 15.0046 10.4058 14.9969 10.3906L9.21213 2.18542C9.17704 2.13123 9.13228 2.08658 9.08094 2.05457C9.02961 2.02255 8.97292 2.00393 8.91481 2H7.71437L10.9733 10.3854C10.9811 10.4046 10.9844 10.4258 10.983 10.447C10.9816 10.4682 10.9756 10.4886 10.9654 10.5062C10.9552 10.5238 10.9413 10.538 10.925 10.5474C10.9087 10.5568 10.8906 10.5611 10.8724 10.5599L5.43983 10.6536C5.38329 10.6556 5.32715 10.6421 5.27596 10.614C5.22477 10.586 5.17997 10.5442 5.14519 10.4922L3.49341 8.14844C3.35948 7.94531 3.10859 7.83594 2.89029 7.83594H2.04833C1.99074 7.83594 1.99922 7.89896 2.01485 7.9625L2.90056 11.6823C2.96751 11.8815 2.96751 12.1029 2.90056 12.3021L2.01395 16.0104C1.98761 16.112 1.99074 16.1667 2.09297 16.1667H2.89297C3.25636 16.1667 3.30591 16.1115 3.49162 15.8385L5.17465 13.4583C5.20974 13.4067 5.2546 13.3653 5.30572 13.3372C5.35684 13.3092 5.41283 13.2954 5.46929 13.2969L10.8568 13.4375C10.8764 13.438 10.8956 13.4441 10.9127 13.4553C10.9299 13.4664 10.9444 13.4823 10.9551 13.5015C10.9658 13.5207 10.9723 13.5426 10.9741 13.5654C10.9758 13.5882 10.9728 13.6112 10.9652 13.6323L7.71437 22H8.90365C8.96165 21.9961 9.01822 21.9775 9.06947 21.9456C9.12073 21.9136 9.16544 21.8691 9.20052 21.8151L14.9974 13.6146C15.0148 13.5833 15.0866 13.5677 15.1174 13.5677L17.9701 13.6562C18.1174 13.6667 18.6214 13.6719 18.7737 13.6719C20.75 13.6719 22 13.038 22 12C22 10.962 20.7554 10.3333 18.7732 10.3333Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Alarm: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.07467 5.23435C7.17577 5.1343 7.25505 5.01439 7.3075 4.88218C7.35995 4.74997 7.38444 4.60832 7.37943 4.46617C7.37441 4.32402 7.34 4.18445 7.27836 4.05627C7.21672 3.92808 7.12919 3.81405 7.02128 3.72138C6.47828 3.25795 5.7884 3.00232 5.07452 3L4.91726 3.00433H4.89418C3.26627 3.1034 1.99664 4.5173 2.00001 6.22216C2.00001 7.1359 2.38474 7.61971 2.68868 8.00685C2.77397 8.11508 2.88089 8.20434 3.00262 8.26893C3.12434 8.33352 3.25819 8.37202 3.39563 8.38197C3.40814 8.38197 3.4293 8.38437 3.49182 8.38437C3.61545 8.38419 3.73776 8.359 3.8514 8.31032C3.96504 8.26164 4.06766 8.19048 4.15308 8.10111L7.07467 5.23435ZM19.1073 3.00529L18.95 3.00048H18.925C18.2105 3.00234 17.5198 3.25801 16.9763 3.72186C16.8686 3.81453 16.7812 3.9285 16.7196 4.0566C16.6581 4.1847 16.6237 4.32415 16.6187 4.46618C16.6137 4.60821 16.6381 4.74974 16.6905 4.88186C16.7428 5.01398 16.822 5.13383 16.9229 5.23387L19.8455 8.10255C19.9311 8.19224 20.034 8.26363 20.148 8.3124C20.262 8.36117 20.3847 8.38631 20.5087 8.38629C20.5702 8.38629 20.5914 8.38629 20.6048 8.38389C20.7422 8.37388 20.876 8.33535 20.9976 8.27076C21.1192 8.20618 21.2261 8.11695 21.3113 8.00877C21.6172 7.62163 21.9981 7.13927 22 6.22408C22.0029 4.5173 20.7333 3.1034 19.1073 3.00529Z"
        fill="currentColor"
      />
      <path
        d="M12.0031 4.53857C7.33816 4.53857 3.5389 8.33543 3.5389 13.0028C3.53725 14.9816 4.23204 16.898 5.50153 18.416L3.76445 20.1535C3.6913 20.2246 3.63301 20.3095 3.59297 20.4033C3.55292 20.4971 3.53193 20.598 3.53121 20.7C3.53049 20.802 3.55005 20.9031 3.58875 20.9974C3.62746 21.0918 3.68455 21.1775 3.75668 21.2496C3.82882 21.3217 3.91457 21.3788 4.00895 21.4174C4.10333 21.4561 4.20446 21.4756 4.30645 21.4749C4.40844 21.4741 4.50927 21.4531 4.60305 21.413C4.69684 21.3729 4.78173 21.3146 4.85277 21.2414L6.58985 19.5043C8.10868 20.7724 10.0245 21.467 12.0031 21.467C13.9817 21.467 15.8975 20.7724 17.4163 19.5043L19.1539 21.2414C19.2249 21.3146 19.3098 21.3729 19.4036 21.413C19.4974 21.4531 19.5982 21.4741 19.7002 21.4749C19.8022 21.4756 19.9033 21.4561 19.9977 21.4174C20.0921 21.3788 20.1778 21.3217 20.25 21.2496C20.3221 21.1775 20.3792 21.0918 20.4179 20.9974C20.4566 20.9031 20.4761 20.802 20.4754 20.7C20.4747 20.598 20.4537 20.4971 20.4137 20.4033C20.3736 20.3095 20.3153 20.2246 20.2422 20.1535L18.5046 18.416C19.7743 16.8981 20.4692 14.9817 20.4673 13.0028C20.4673 8.33784 16.6704 4.53857 12.0031 4.53857ZM12.7725 13.0028C12.7725 13.2068 12.6915 13.4025 12.5472 13.5469C12.4029 13.6912 12.2072 13.7722 12.0031 13.7722H8.15572C7.95165 13.7722 7.75593 13.6912 7.61162 13.5469C7.46732 13.4025 7.38625 13.2068 7.38625 13.0028C7.38625 12.7987 7.46732 12.603 7.61162 12.4587C7.75593 12.3143 7.95165 12.2333 8.15572 12.2333H11.2336V7.61646C11.2336 7.41238 11.3147 7.21666 11.459 7.07236C11.6033 6.92806 11.799 6.84699 12.0031 6.84699C12.2072 6.84699 12.4029 6.92806 12.5472 7.07236C12.6915 7.21666 12.7725 7.41238 12.7725 7.61646V13.0028Z"
        fill="currentColor"
      />
    </svg>
  ),
  AlarmOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.34 13.0036C20.34 11.3549 19.8511 9.74311 18.9351 8.3722C18.0191 7.00129 16.7171 5.9328 15.1938 5.30184C13.6706 4.67088 11.9944 4.50579 10.3773 4.82745C8.76021 5.14911 7.27481 5.94308 6.10895 7.10894C4.94309 8.2748 4.14912 9.7602 3.82746 11.3773C3.5058 12.9944 3.67089 14.6706 4.30185 16.1938C4.93281 17.7171 6.0013 19.0191 7.37221 19.9351C8.74312 20.8511 10.3549 21.34 12.0036 21.34C14.2146 21.34 16.335 20.4617 17.8983 18.8983C19.4617 17.335 20.34 15.2146 20.34 13.0036ZM6.06659 3.58407C5.62913 3.20972 5.07303 3.00275 4.49727 3L4.35191 3.00417C3.02069 3.08441 1.99636 4.25045 2.00001 5.65722C2.00001 6.34549 2.24281 6.66644 2.56688 7.07596C2.58701 7.10228 2.61244 7.12408 2.64151 7.13996C2.67059 7.15585 2.70267 7.16546 2.73569 7.16818H2.78154C2.80736 7.16772 2.83272 7.16132 2.85567 7.14949C2.87862 7.13765 2.89854 7.1207 2.91388 7.09993L6.08014 3.98994C6.10718 3.9626 6.1283 3.92999 6.14219 3.89414C6.15608 3.85828 6.16245 3.81995 6.1609 3.78153C6.15959 3.74391 6.15053 3.70695 6.13431 3.67298C6.11808 3.639 6.09503 3.60874 6.06659 3.58407V3.58407ZM17.9334 3.58407C18.3709 3.20972 18.927 3.00275 19.5027 3L19.6481 3.00417C20.9793 3.08441 22.0036 4.25045 22 5.65722C22 6.34549 21.7572 6.66644 21.4331 7.07596C21.4129 7.10218 21.3875 7.12388 21.3584 7.13968C21.3293 7.15547 21.2973 7.165 21.2643 7.16766H21.2185C21.1926 7.1672 21.1673 7.1608 21.1443 7.14897C21.1214 7.13713 21.1015 7.12017 21.0861 7.09941L17.9199 3.98994C17.8928 3.9626 17.8717 3.92999 17.8578 3.89414C17.8439 3.85828 17.8376 3.81995 17.8391 3.78153C17.8404 3.74391 17.8495 3.70695 17.8657 3.67298C17.8819 3.639 17.905 3.60874 17.9334 3.58407V3.58407Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M12.0034 7.16736V13.0028H7.83518M20.3397 21.3392L18.2556 19.2551M3.66699 21.3392L5.75108 19.2551"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Album: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3846 4.53846H6.61538C6.41137 4.53846 6.21572 4.45742 6.07146 4.31316C5.9272 4.1689 5.84615 3.97324 5.84615 3.76923C5.84615 3.56522 5.9272 3.36956 6.07146 3.2253C6.21572 3.08104 6.41137 3 6.61538 3H17.3846C17.5886 3 17.7843 3.08104 17.9285 3.2253C18.0728 3.36956 18.1538 3.56522 18.1538 3.76923C18.1538 3.97324 18.0728 4.1689 17.9285 4.31316C17.7843 4.45742 17.5886 4.53846 17.3846 4.53846ZM18.9231 6.84615H5.07692C4.87291 6.84615 4.67725 6.76511 4.53299 6.62085C4.38874 6.47659 4.30769 6.28094 4.30769 6.07692C4.30769 5.87291 4.38874 5.67725 4.53299 5.533C4.67725 5.38874 4.87291 5.30769 5.07692 5.30769H18.9231C19.1271 5.30769 19.3227 5.38874 19.467 5.533C19.6113 5.67725 19.6923 5.87291 19.6923 6.07692C19.6923 6.28094 19.6113 6.47659 19.467 6.62085C19.3227 6.76511 19.1271 6.84615 18.9231 6.84615ZM19.8428 21.4615H4.15721C3.58528 21.4609 3.03695 21.2334 2.63254 20.829C2.22812 20.4246 2.00064 19.8763 2 19.3043V9.7726C2.00064 9.20066 2.22812 8.65234 2.63254 8.24792C3.03695 7.8435 3.58528 7.61602 4.15721 7.61539H19.8428C20.4147 7.61602 20.963 7.8435 21.3675 8.24792C21.7719 8.65234 21.9994 9.20066 22 9.7726V19.3043C21.9994 19.8763 21.7719 20.4246 21.3675 20.829C20.963 21.2334 20.4147 21.4609 19.8428 21.4615Z"
        fill="currentColor"
      />
    </svg>
  ),
  AlbumOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4964 7.99945H3.50365C2.67321 7.99945 2 8.67266 2 9.5031V19.8291C2 20.6596 2.67321 21.3328 3.50365 21.3328H20.4964C21.3268 21.3328 22 20.6596 22 19.8291V9.5031C22 8.67266 21.3268 7.99945 20.4964 7.99945Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M6.16691 3H17.8336H6.16691ZM4.50024 5.5H19.5002H4.50024Z"
        fill="currentColor"
      />
      <path
        d="M4.50024 5.5H19.5002M6.16691 3H17.8336H6.16691Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  ),
  Alert: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9109 2.00006C11.4189 2.00006 10.9689 2.41822 11.0018 2.90911L11.4563 15.1812C11.4563 15.3017 11.5042 15.4174 11.5895 15.5026C11.6747 15.5878 11.7903 15.6357 11.9109 15.6357C12.0314 15.6357 12.147 15.5878 12.2323 15.5026C12.3175 15.4174 12.3654 15.3017 12.3654 15.1812L12.8199 2.90911C12.8529 2.41822 12.4029 2.00006 11.9109 2.00006Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2027 2.94872C10.1431 1.93401 11.0322 1.20001 11.9108 1.20001C12.7894 1.20001 13.6785 1.93401 13.6189 2.94872L13.1652 15.1996C13.1604 15.5257 13.0288 15.8373 12.7979 16.0682C12.5626 16.3035 12.2435 16.4357 11.9108 16.4357C11.5781 16.4357 11.259 16.3035 11.0237 16.0682C10.7928 15.8373 10.6612 15.5257 10.6564 15.1996L10.2027 2.94872ZM11.7987 2.86916C11.7986 2.86914 11.7988 2.86831 11.7995 2.86672C11.7992 2.86838 11.7988 2.86918 11.7987 2.86916ZM11.8005 2.86468C11.8029 2.86032 11.808 2.85289 11.8184 2.8428C11.8319 2.82953 11.8494 2.81777 11.8681 2.80987C11.8864 2.80213 11.9012 2.80001 11.9108 2.80001C11.9204 2.80001 11.9352 2.80213 11.9535 2.80987C11.9722 2.81777 11.9897 2.82953 12.0032 2.8428C12.0136 2.85289 12.0187 2.86032 12.0211 2.86468C12.0208 2.8696 12.0206 2.87452 12.0204 2.87945L11.9108 5.83843L11.8012 2.87945C11.801 2.87452 11.8008 2.8696 11.8005 2.86468ZM12.0229 2.86916C12.0228 2.86918 12.0224 2.86838 12.0221 2.86672C12.0228 2.86831 12.023 2.86914 12.0229 2.86916Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.202 21.0905C10.202 20.1464 10.9674 19.381 11.9115 19.381C12.8556 19.381 13.621 20.1464 13.621 21.0905C13.621 22.0347 12.8556 22.8 11.9115 22.8C10.9674 22.8 10.202 22.0347 10.202 21.0905Z"
        fill="currentColor"
      />
    </svg>
  ),
  AlertCircle: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48606 2 2 6.48606 2 12C2 17.5139 6.48606 22 12 22C17.5139 22 22 17.5139 22 12C22 6.48606 17.5139 2 12 2ZM12 17.3803C11.8098 17.3803 11.6239 17.3239 11.4658 17.2182C11.3077 17.1126 11.1844 16.9624 11.1117 16.7867C11.0389 16.611 11.0198 16.4177 11.0569 16.2312C11.094 16.0446 11.1856 15.8733 11.3201 15.7388C11.4546 15.6044 11.6259 15.5128 11.8124 15.4757C11.9989 15.4386 12.1923 15.4576 12.368 15.5304C12.5437 15.6032 12.6938 15.7264 12.7995 15.8845C12.9051 16.0427 12.9615 16.2286 12.9615 16.4188C12.9615 16.6738 12.8602 16.9183 12.6799 17.0987C12.4996 17.279 12.255 17.3803 12 17.3803ZM13.0442 7.70962L12.7683 13.575C12.7683 13.779 12.6872 13.9747 12.543 14.1189C12.3987 14.2632 12.2031 14.3442 11.999 14.3442C11.795 14.3442 11.5994 14.2632 11.4551 14.1189C11.3109 13.9747 11.2298 13.779 11.2298 13.575L10.9538 7.7125V7.7101C10.9478 7.5692 10.9703 7.42853 11.0201 7.29657C11.0698 7.1646 11.1458 7.04407 11.2433 6.94223C11.3409 6.84039 11.4581 6.75935 11.5878 6.70399C11.7175 6.64862 11.857 6.62008 11.9981 6.62008C12.1391 6.62008 12.2787 6.64862 12.4084 6.70399C12.5381 6.75935 12.6553 6.84039 12.7528 6.94223C12.8504 7.04407 12.9263 7.1646 12.9761 7.29657C13.0258 7.42853 13.0484 7.5692 13.0423 7.7101L13.0442 7.70962Z"
        fill="currentColor"
      />
    </svg>
  ),
  AlertCircleOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12C22 6.47917 17.5208 2 12 2C6.47917 2 2 6.47917 2 12C2 17.5208 6.47917 22 12 22C17.5208 22 22 17.5208 22 12Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M11.701 7.31459L11.9999 13.6662L12.2984 7.31459C12.3002 7.27398 12.2938 7.23343 12.2794 7.19541C12.2651 7.15738 12.2431 7.12268 12.2149 7.09344C12.1866 7.06419 12.1527 7.041 12.1153 7.0253C12.0778 7.00959 12.0375 7.00169 11.9968 7.00209V7.00209C11.9567 7.00247 11.917 7.01093 11.8802 7.02699C11.8434 7.04304 11.8101 7.06634 11.7825 7.09551C11.7549 7.12467 11.7335 7.15911 11.7195 7.19675C11.7055 7.23439 11.6992 7.27447 11.701 7.31459V7.31459Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9999 17.8286C11.7939 17.8286 11.5925 17.7675 11.4212 17.653C11.2499 17.5386 11.1164 17.3759 11.0375 17.1855C10.9587 16.9952 10.9381 16.7858 10.9783 16.5837C11.0185 16.3816 11.1177 16.196 11.2633 16.0503C11.409 15.9047 11.5946 15.8054 11.7967 15.7653C11.9988 15.7251 12.2082 15.7457 12.3985 15.8245C12.5889 15.9034 12.7516 16.0369 12.866 16.2082C12.9805 16.3795 13.0416 16.5809 13.0416 16.7869C13.0416 17.0632 12.9318 17.3281 12.7365 17.5235C12.5411 17.7188 12.2762 17.8286 11.9999 17.8286Z"
        fill="currentColor"
      />
    </svg>
  ),
  AlertOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9107 2C11.4187 2 10.9688 2.41816 11.0017 2.90904L11.4562 15.1811C11.4562 15.3017 11.5041 15.4173 11.5894 15.5025C11.6746 15.5878 11.7902 15.6357 11.9107 15.6357C12.0313 15.6357 12.1469 15.5878 12.2321 15.5025C12.3174 15.4173 12.3653 15.3017 12.3653 15.1811L12.8198 2.90904C12.8527 2.41816 12.4028 2 11.9107 2Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9107 22C12.413 22 12.8202 21.5928 12.8202 21.0905C12.8202 20.5882 12.413 20.181 11.9107 20.181C11.4084 20.181 11.0012 20.5882 11.0012 21.0905C11.0012 21.5928 11.4084 22 11.9107 22Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Analytics: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.3324 7C20.061 7.00007 19.7938 7.06639 19.5539 7.19321C19.314 7.32002 19.1087 7.50349 18.9559 7.72767C18.803 7.95186 18.7072 8.20998 18.6768 8.47961C18.6463 8.74924 18.6822 9.02222 18.7812 9.27484L15.2744 12.7817C14.8835 12.6278 14.4487 12.6278 14.0578 12.7817L11.5509 10.2748C11.6502 10.0221 11.6862 9.74899 11.6559 9.47921C11.6255 9.20944 11.5298 8.95115 11.3769 8.72682C11.224 8.50249 11.0186 8.3189 10.7786 8.19203C10.5386 8.06516 10.2712 7.99884 9.99975 7.99884C9.72827 7.99884 9.46091 8.06516 9.2209 8.19203C8.98089 8.3189 8.77551 8.50249 8.62262 8.72682C8.46973 8.95115 8.37396 9.20944 8.34363 9.47921C8.3133 9.74899 8.34934 10.0221 8.44861 10.2748L4.27515 14.4482C3.91873 14.3084 3.52503 14.2956 3.16026 14.4119C2.79549 14.5282 2.48189 14.7666 2.27219 15.0869C2.0625 15.4072 1.96949 15.79 2.00882 16.1709C2.04814 16.5517 2.2174 16.9074 2.48812 17.1781C2.75885 17.4488 3.11454 17.6181 3.49538 17.6574C3.87622 17.6967 4.25899 17.6037 4.57932 17.394C4.89966 17.1843 5.13802 16.8707 5.25434 16.506C5.37065 16.1412 5.35782 15.7475 5.218 15.3911L9.39146 11.2176C9.78239 11.3715 10.2171 11.3715 10.608 11.2176L13.1149 13.7245C13.0157 13.9772 12.9796 14.2503 13.01 14.5201C13.0403 14.7899 13.1361 15.0482 13.289 15.2725C13.4419 15.4968 13.6472 15.6804 13.8872 15.8073C14.1272 15.9341 14.3946 16.0005 14.6661 16.0005C14.9376 16.0005 15.2049 15.9341 15.4449 15.8073C15.6849 15.6804 15.8903 15.4968 16.0432 15.2725C16.1961 15.0482 16.2919 14.7899 16.3222 14.5201C16.3525 14.2503 16.3165 13.9772 16.2172 13.7245L19.7241 10.2177C19.9523 10.3073 20.1974 10.3455 20.4421 10.3296C20.6868 10.3136 20.9249 10.2438 21.1395 10.1252C21.3541 10.0066 21.5398 9.84218 21.6836 9.64355C21.8273 9.44493 21.9255 9.21703 21.971 8.97612C22.0165 8.73521 22.0084 8.48722 21.9471 8.24983C21.8858 8.01244 21.7728 7.7915 21.6163 7.60277C21.4598 7.41404 21.2636 7.26216 21.0417 7.15797C20.8197 7.05378 20.5775 6.99984 20.3324 7Z"
        fill="currentColor"
      />
    </svg>
  ),
  AnalyticsOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4985 12.4998L18.9985 9.99976M11.4985 10.9998L12.9985 12.4998M4.49854 14.4998L7.99854 10.9998"
        stroke="currentColor"
        strokeWidth="1.48846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9286 9.88706C21.9313 9.88706 22.7442 9.07417 22.7442 8.07142C22.7442 7.06866 21.9313 6.25577 20.9286 6.25577C19.9258 6.25577 19.1129 7.06866 19.1129 8.07142C19.1129 9.07417 19.9258 9.88706 20.9286 9.88706Z"
        stroke="currentColor"
        strokeWidth="1.48846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8569 15.9582C15.8597 15.9582 16.6726 15.1453 16.6726 14.1426C16.6726 13.1398 15.8597 12.3269 14.8569 12.3269C13.8542 12.3269 13.0413 13.1398 13.0413 14.1426C13.0413 15.1453 13.8542 15.9582 14.8569 15.9582Z"
        stroke="currentColor"
        strokeWidth="1.48846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.8573 10.958C10.8601 10.958 11.673 10.1451 11.673 9.14234C11.673 8.13959 10.8601 7.32669 9.8573 7.32669C8.85455 7.32669 8.04166 8.13959 8.04166 9.14234C8.04166 10.1451 8.85455 10.958 9.8573 10.958Z"
        stroke="currentColor"
        strokeWidth="1.48846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.07142 17.7439C4.07417 17.7439 4.88706 16.931 4.88706 15.9282C4.88706 14.9255 4.07417 14.1126 3.07142 14.1126C2.06866 14.1126 1.25577 14.9255 1.25577 15.9282C1.25577 16.931 2.06866 17.7439 3.07142 17.7439Z"
        stroke="currentColor"
        strokeWidth="1.48846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ArrowBack: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2308 21.4615L2 12.2308L11.2308 3M3.28205 12.2308H22"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ArrowDown: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2876 2.00006C12.6967 2.00006 13.0283 2.3317 13.0283 2.7408V19.471L20.3108 12.1885C20.6001 11.8993 21.0691 11.8993 21.3584 12.1885C21.6476 12.4778 21.6476 12.9468 21.3584 13.2361L12.8113 21.7831C12.6724 21.922 12.484 22.0001 12.2876 22.0001C12.0911 22.0001 11.9027 21.922 11.7638 21.7831L3.21677 13.2361C2.9275 12.9468 2.9275 12.4778 3.21677 12.1885C3.50605 11.8993 3.97506 11.8993 4.26434 12.1885L11.5468 19.471V2.7408C11.5468 2.3317 11.8785 2.00006 12.2876 2.00006Z"
        fill="currentColor"
      />
    </svg>
  ),
  ArrowUp: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 11.2308L12.2308 2.00006L21.4615 11.2308M12.2308 3.28211V22.0001"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Camera: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0002 15.5702C13.5782 15.5702 14.8574 14.291 14.8574 12.713C14.8574 11.1351 13.5782 9.8559 12.0002 9.8559C10.4223 9.8559 9.14307 11.1351 9.14307 12.713C9.14307 14.291 10.4223 15.5702 12.0002 15.5702Z"
        fill="currentColor"
      />
      <path
        d="M19.8571 7.00009H17.2232C17.0893 7.00009 16.9232 6.91348 16.7938 6.77687L15.6357 4.94919C15.6174 4.92019 15.597 4.89258 15.5746 4.86661C15.1746 4.40009 14.6339 4.14294 14.0536 4.14294H9.94643C9.36607 4.14294 8.82545 4.40009 8.42545 4.86661C8.40304 4.89258 8.3826 4.92019 8.36429 4.94919L7.20625 6.77955C7.10714 6.88759 6.96786 7.00277 6.82143 7.00277V6.64562C6.82143 6.45618 6.74617 6.2745 6.61222 6.14055C6.47826 6.00659 6.29658 5.93134 6.10714 5.93134H5.03571C4.84627 5.93134 4.66459 6.00659 4.53064 6.14055C4.39668 6.2745 4.32143 6.45618 4.32143 6.64562V7.00277H4.14286C3.57472 7.00336 3.03002 7.22931 2.62828 7.63105C2.22655 8.03278 2.00059 8.57748 2 9.14562V17.7144C2.00059 18.2825 2.22655 18.8272 2.62828 19.229C3.03002 19.6307 3.57472 19.8566 4.14286 19.8572H19.8571C20.4253 19.8566 20.97 19.6307 21.3717 19.229C21.7735 18.8272 21.9994 18.2825 22 17.7144V9.14294C21.9994 8.57481 21.7735 8.0301 21.3717 7.62837C20.97 7.22663 20.4253 7.00068 19.8571 7.00009ZM12 17.0001C11.1524 17.0001 10.3238 16.7487 9.61898 16.2778C8.9142 15.8069 8.36489 15.1376 8.04052 14.3544C7.71614 13.5713 7.63127 12.7096 7.79664 11.8783C7.962 11.0469 8.37017 10.2833 8.96954 9.68392C9.56891 9.08455 10.3326 8.67637 11.1639 8.51101C11.9952 8.34564 12.857 8.43051 13.6401 8.75489C14.4232 9.07927 15.0925 9.62858 15.5634 10.3334C16.0344 11.0381 16.2857 11.8667 16.2857 12.7144C16.2844 13.8506 15.8325 14.94 15.029 15.7434C14.2256 16.5468 13.1362 16.9988 12 17.0001Z"
        fill="currentColor"
      />
    </svg>
  ),
  CameraOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5452 6.8397L15.2654 4.81758C14.9957 4.50316 14.626 4.30701 14.2115 4.30701H9.78846C9.37404 4.30701 9.00433 4.50316 8.73462 4.81758L7.45481 6.8397C7.1851 7.1546 6.8375 7.38393 6.42308 7.38393H3.53846C3.13044 7.38393 2.73912 7.54602 2.4506 7.83454C2.16209 8.12305 2 8.51437 2 8.92239V18.1532C2 18.5612 2.16209 18.9525 2.4506 19.241C2.73912 19.5295 3.13044 19.6916 3.53846 19.6916H20.4615C20.8696 19.6916 21.2609 19.5295 21.5494 19.241C21.8379 18.9525 22 18.5612 22 18.1532V8.92239C22 8.51437 21.8379 8.12305 21.5494 7.83454C21.2609 7.54602 20.8696 7.38393 20.4615 7.38393H17.625C17.2091 7.38393 16.8149 7.1546 16.5452 6.8397Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0001 16.6136C14.1243 16.6136 15.8462 14.8916 15.8462 12.7674C15.8462 10.6432 14.1243 8.92126 12.0001 8.92126C9.87591 8.92126 8.15393 10.6432 8.15393 12.7674C8.15393 14.8916 9.87591 16.6136 12.0001 16.6136Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M5.65416 7.28837V6.23016H4.49976V7.28837"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  BulbOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4999 22H13.357M9.78561 19.8571H14.0713M14.0713 17.7143V16.6429C14.0713 15.3482 15.4794 14.1237 16.3928 13.25C17.6802 12.0192 18.357 10.3656 18.357 8.42859C18.357 4.85716 15.5119 2.00002 11.9285 2.00002C11.0836 1.99767 10.2466 2.16234 9.46558 2.48457C8.68456 2.8068 7.97495 3.28024 7.37753 3.87765C6.78011 4.47507 6.30668 5.18468 5.98445 5.9657C5.66222 6.74671 5.49755 7.58372 5.4999 8.42859C5.4999 10.2964 6.20571 12.0621 7.46419 13.25C8.37267 14.1076 9.78561 15.3348 9.78561 16.6429V17.7143H14.0713Z"
        stroke="currentColor"
      />
    </svg>
  ),
  CaretDown: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.35697 7.97544L10.8887 17.9318C11.0262 18.0922 11.1968 18.2209 11.3888 18.3092C11.5807 18.3975 11.7895 18.4432 12.0008 18.4432C12.2121 18.4432 12.4209 18.3975 12.6128 18.3092C12.8048 18.2209 12.9754 18.0922 13.1129 17.9318L21.6446 7.97544C22.4589 7.0251 21.7838 5.55716 20.5325 5.55716H3.46662C2.21536 5.55716 1.54029 7.0251 2.35697 7.97544Z"
        fill="currentColor"
      />
    </svg>
  ),

  CaretUp: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(180)"
    >
      <path
        d="M2.35697 7.97544L10.8887 17.9318C11.0262 18.0922 11.1968 18.2209 11.3888 18.3092C11.5807 18.3975 11.7895 18.4432 12.0008 18.4432C12.2121 18.4432 12.4209 18.3975 12.6128 18.3092C12.8048 18.2209 12.9754 18.0922 13.1129 17.9318L21.6446 7.97544C22.4589 7.0251 21.7838 5.55716 20.5325 5.55716H3.46662C2.21536 5.55716 1.54029 7.0251 2.35697 7.97544Z"
        fill="currentColor"
      />
    </svg>
  ),

  CaretDownOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.35697 7.97544L10.8887 17.9318C11.0262 18.0922 11.1968 18.2209 11.3888 18.3092C11.5807 18.3975 11.7895 18.4432 12.0008 18.4432C12.2121 18.4432 12.4209 18.3975 12.6128 18.3092C12.8048 18.2209 12.9754 18.0922 13.1129 17.9318L21.6446 7.97544C22.4589 7.0251 21.7838 5.55716 20.5325 5.55716H3.46662C2.21536 5.55716 1.54029 7.0251 2.35697 7.97544Z"
        fill="currentColor"
      />
    </svg>
  ),
  Chatbox: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 21.5714C6.81056 21.5714 6.62888 21.4962 6.49492 21.3622C6.36097 21.2283 6.28571 21.0466 6.28571 20.8571V18H5.21429C4.36209 17.9991 3.54508 17.6601 2.94249 17.0575C2.3399 16.4549 2.00095 15.6379 2 14.7857V6.21429C2.00095 5.36209 2.3399 4.54508 2.94249 3.94249C3.54508 3.3399 4.36209 3.00095 5.21429 3H18.7857C19.6379 3.00095 20.4549 3.3399 21.0575 3.94249C21.6601 4.54508 21.9991 5.36209 22 6.21429V14.7857C21.9991 15.6379 21.6601 16.4549 21.0575 17.0575C20.4549 17.6601 19.6379 17.9991 18.7857 18H11.542L7.45759 21.4058C7.32905 21.5127 7.16718 21.5713 7 21.5714Z"
        fill="currentColor"
      />
    </svg>
  ),
  ChatboxOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.3077 3H4.69231C3.97889 3.002 3.29527 3.282 2.7908 3.77882C2.28633 4.27564 2.00203 4.9489 2 5.65152V14.7424C2.00203 15.445 2.28633 16.1183 2.7908 16.6151C3.29527 17.1119 3.97889 17.3919 4.69231 17.3939H6.61538V21.1818L11.1212 17.482C11.1903 17.4251 11.2776 17.3939 11.3678 17.3939H19.3077C20.0211 17.3919 20.7047 17.1119 21.2092 16.6151C21.7137 16.1183 21.998 15.445 22 14.7424V5.65152C21.998 4.9489 21.7137 4.27564 21.2092 3.77882C20.7047 3.282 20.0211 3.002 19.3077 3V3Z"
        stroke="currentColor"
        strokeWidth="1.62"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Checkmark: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 3.36564L5.33337 14.0323L1.33337 10.0323"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CheckmarkCircle: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 2C6.48581 2 1.99976 6.48606 1.99976 12C1.99976 17.5139 6.48581 22 11.9998 22C17.5137 22 21.9998 17.5139 21.9998 12C21.9998 6.48606 17.5137 2 11.9998 2ZM17.2041 8.64856L10.7425 16.3409C10.6717 16.4253 10.5835 16.4935 10.4839 16.5409C10.3844 16.5882 10.2758 16.6136 10.1656 16.6154H10.1526C10.0448 16.6153 9.93822 16.5926 9.83974 16.5487C9.74126 16.5048 9.65311 16.4407 9.58101 16.3606L6.81178 13.2837C6.74145 13.2091 6.68674 13.1212 6.65087 13.0251C6.61499 12.9291 6.59868 12.8268 6.60288 12.7244C6.60709 12.622 6.63173 12.5214 6.67535 12.4286C6.71897 12.3359 6.7807 12.2527 6.85691 12.1842C6.93311 12.1156 7.02226 12.0629 7.1191 12.0293C7.21595 11.9957 7.31854 11.9817 7.42085 11.9883C7.52315 11.9949 7.62311 12.0219 7.71485 12.0676C7.80659 12.1134 7.88825 12.177 7.95504 12.2548L10.1324 14.674L16.0262 7.65913C16.1584 7.50629 16.3454 7.41161 16.5469 7.39555C16.7483 7.3795 16.948 7.44337 17.1028 7.57335C17.2575 7.70333 17.3549 7.88899 17.3738 8.09018C17.3928 8.29138 17.3318 8.49196 17.2041 8.64856Z"
        fill="currentColor"
      />
    </svg>
  ),
  CheckmarkCircleOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12C22 6.47917 17.5208 2 12 2C6.47917 2 2 6.47917 2 12C2 17.5208 6.47917 22 12 22C17.5208 22 22 17.5208 22 12Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M16.9998 7.83325L9.99976 16.1666L6.99976 12.8333"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CheckmarkDone: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6666 3.89661L7.4871 12.1017L3.21343 7.65813M4.41018 12.1017L1.33325 9.02482M11.5897 3.89661L7.23069 8.89661"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  ChevronBack: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6428 2.26627C17.9978 2.62129 17.9978 3.19689 17.6428 3.55192L9.19474 12L17.6428 20.4481C17.9978 20.8031 17.9978 21.3787 17.6428 21.7337C17.2878 22.0888 16.7122 22.0888 16.3572 21.7337L7.26627 12.6428C6.91124 12.2878 6.91124 11.7122 7.26627 11.3572L16.3572 2.26627C16.7122 1.91124 17.2878 1.91124 17.6428 2.26627Z"
        fill="currentColor"
      />
    </svg>
  ),
  ChevronBackOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 2L7 12L17 22"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ChevronDown: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.26627 7.26627C2.62129 6.91124 3.19689 6.91124 3.55191 7.26627L12 15.7144L20.4481 7.26627C20.8031 6.91124 21.3787 6.91124 21.7337 7.26627C22.0888 7.62129 22.0888 8.19689 21.7337 8.55192L12.6428 17.6428C12.2878 17.9978 11.7122 17.9978 11.3572 17.6428L2.26627 8.55192C1.91124 8.19689 1.91124 7.62129 2.26627 7.26627Z"
        fill="currentColor"
      />
    </svg>
  ),
  ChevronDownOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.00232 7.00232L12 17L21.9977 7.00232"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ChevronForward: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.26623 2.26627C6.91121 2.62129 6.91121 3.19689 7.26623 3.55192L15.7143 12L7.26623 20.4481C6.91121 20.8031 6.91121 21.3787 7.26623 21.7337C7.62125 22.0888 8.19686 22.0888 8.55188 21.7337L17.6428 12.6428C17.9978 12.2878 17.9978 11.7122 17.6428 11.3572L8.55188 2.26627C8.19686 1.91124 7.62125 1.91124 7.26623 2.26627Z"
        fill="currentColor"
      />
    </svg>
  ),
  ChevronForwardOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 2L17 12L7 22"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ChevronUp: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7337 17.6428C21.3787 17.9978 20.8031 17.9978 20.4481 17.6428L12 9.19474L3.55191 17.6428C3.19689 17.9978 2.62129 17.9978 2.26627 17.6428C1.91124 17.2878 1.91124 16.7122 2.26627 16.3572L11.3572 7.26627C11.7122 6.91124 12.2878 6.91124 12.6428 7.26627L21.7337 16.3572C22.0888 16.7122 22.0888 17.2878 21.7337 17.6428Z"
        fill="currentColor"
      />
    </svg>
  ),
  ChevronUpOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9954 16.9977L11.9977 7L2 16.9977"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CircleWithUpArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.7779 7.76993L8.00012 5.01368L5.22234 7.76993M8.00012 5.39667L8.00012 10.9859"
        stroke="currentColor"
        strokeWidth="1.07"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99999 1.33331C4.31944 1.33331 1.33333 4.31942 1.33333 7.99998C1.33333 11.6805 4.31944 14.6666 7.99999 14.6666C11.6805 14.6666 14.6667 11.6805 14.6667 7.99998C14.6667 4.31942 11.6805 1.33331 7.99999 1.33331Z"
        stroke="currentColor"
        strokeWidth="1.07"
        strokeMiterlimit="10"
      />

      <defs>
        <path id="clip0_1607_22150">
          <rect width="16" height="16" fill="white" />
        </path>
      </defs>
    </svg>
  ),
  Circle: (
    <svg
      width="8"
      height="16"
      viewBox="0 0 8 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="8" r="4" fill="currentColor" />
    </svg>
  ),
  CloseOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 2L2 22M22 22L2 2L22 22Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CloseOutlineFilled: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4948 12L21.478 5.01684C21.8094 4.68601 21.9958 4.23707 21.9962 3.76879C21.9966 3.3005 21.811 2.85123 21.4802 2.51981C21.1494 2.18839 20.7004 2.00197 20.2321 2.00156C19.7638 2.00115 19.3146 2.18677 18.9832 2.51761L12 9.50077L5.01684 2.51761C4.68542 2.18619 4.23592 2 3.76723 2C3.29853 2 2.84903 2.18619 2.51761 2.51761C2.18619 2.84903 2 3.29853 2 3.76723C2 4.23592 2.18619 4.68542 2.51761 5.01684L9.50077 12L2.51761 18.9832C2.18619 19.3146 2 19.7641 2 20.2328C2 20.7015 2.18619 21.151 2.51761 21.4824C2.84903 21.8138 3.29853 22 3.76723 22C4.23592 22 4.68542 21.8138 5.01684 21.4824L12 14.4992L18.9832 21.4824C19.3146 21.8138 19.7641 22 20.2328 22C20.7015 22 21.151 21.8138 21.4824 21.4824C21.8138 21.151 22 20.7015 22 20.2328C22 19.7641 21.8138 19.3146 21.4824 18.9832L14.4948 12Z"
        fill="currentColor"
      />
    </svg>
  ),
  Divider: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2"
      height="36"
      viewBox="0 0 2 36"
      fill="none"
    >
      <path d="M1 0V36" stroke="currentColor" />
    </svg>
  ),
  DownloadCloud: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.465 9.15253C19.947 8.82323 19.2997 8.58378 18.5868 8.45214C18.4667 8.42913 18.356 8.37138 18.2683 8.28605C18.1807 8.20071 18.1201 8.09154 18.0939 7.97206C17.7868 6.62401 17.1329 5.46698 16.174 4.59003C15.0529 3.56464 13.5708 3.00018 12.0001 3.00018C10.6193 3.00018 9.34387 3.433 8.31379 4.25018C7.61809 4.80486 7.05772 5.51056 6.67512 6.31386C6.63256 6.40444 6.56893 6.48351 6.48956 6.54447C6.41018 6.60543 6.31737 6.6465 6.21887 6.66425C5.15911 6.85565 4.24504 7.23768 3.54661 7.78534C2.53528 8.57948 2.00012 9.70175 2.00012 11.0314C2.00012 13.6642 4.18489 15.5002 7.31262 15.5002H11.3751V10.5178C11.3751 10.1814 11.6337 9.89276 11.97 9.87597C12.0545 9.87189 12.139 9.88502 12.2183 9.91455C12.2976 9.94409 12.37 9.98941 12.4313 10.0478C12.4925 10.1061 12.5413 10.1763 12.5746 10.2541C12.6079 10.3319 12.6251 10.4156 12.6251 10.5002V15.5002H17.4689C20.3064 15.5002 22.0001 14.1627 22.0001 11.9221C22.0001 10.7482 21.4693 9.79042 20.465 9.15253ZM11.3751 18.3682L9.94153 16.9369C9.82363 16.8226 9.6655 16.7594 9.50132 16.7607C9.33715 16.7621 9.18011 16.828 9.06414 16.9443C8.94817 17.0605 8.8826 17.2177 8.88158 17.3819C8.88057 17.546 8.9442 17.704 9.05872 17.8217L11.5587 20.3174C11.6759 20.4343 11.8346 20.4999 12.0001 20.4999C12.1656 20.4999 12.3244 20.4343 12.4415 20.3174L14.9415 17.8217C15.056 17.704 15.1197 17.546 15.1187 17.3819C15.1176 17.2177 15.0521 17.0605 14.9361 16.9443C14.8201 16.828 14.6631 16.7621 14.4989 16.7607C14.3347 16.7594 14.1766 16.8226 14.0587 16.9369L12.6251 18.3682V15.5002H11.3751V18.3682Z"
        fill="currentColor"
      />
    </svg>
  ),
  DownloadCloudOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8333 15C20.125 15 22 14.1162 22 11.85C22 9.58375 19.7917 8.78875 18 8.7C17.6296 5.15583 15.0417 3 12 3C9.125 3 7.27333 4.90792 6.66667 6.8C4.16667 7.0375 2 8.295 2 10.9C2 13.505 4.25 15 7 15"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.11645 17.3485L11.7831 20.011L14.4498 17.3485M11.7831 10.011L11.7831 19.3456"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Download: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M7.00008 0.333313C6.61833 0.333313 6.30599 0.655203 6.30599 1.04862V8.25895L4.50485 6.40272C4.23416 6.12375 3.79341 6.12375 3.52272 6.40272C3.25203 6.68169 3.25203 7.13592 3.52272 7.41489L6.50728 10.4907C6.52463 10.5086 6.54198 10.5193 6.56281 10.5372C6.58016 10.5515 6.59404 10.5658 6.61139 10.5801C6.63915 10.598 6.66692 10.6123 6.69468 10.6266C6.70509 10.6338 6.71897 10.6409 6.72939 10.6445C6.76409 10.6588 6.80226 10.6695 6.83697 10.6803C6.84391 10.6803 6.85085 10.6839 6.85779 10.6874C6.90291 10.6982 6.95149 10.7017 6.99661 10.7017C7.04172 10.7017 7.09031 10.6982 7.13542 10.6874C7.14236 10.6874 7.14931 10.6839 7.15625 10.6803C7.19442 10.6731 7.22912 10.6624 7.26383 10.6445C7.27771 10.6409 7.28812 10.6302 7.29853 10.6266C7.3263 10.6123 7.35406 10.598 7.38182 10.5801C7.39917 10.5694 7.41653 10.5515 7.43041 10.5372C7.44776 10.5229 7.46858 10.5086 7.48594 10.4907L10.4705 7.41489C10.7412 7.13592 10.7412 6.68169 10.4705 6.40272C10.1998 6.12375 9.75906 6.12375 9.48836 6.40272L7.69416 8.25895V1.04862C7.69416 0.655203 7.38182 0.333313 7.00008 0.333313Z" />
      <path d="M1.02746 9.2818C0.645711 9.2818 0.333374 9.60369 0.333374 9.99711V10.9807C0.333374 12.4614 1.5029 13.6667 2.93966 13.6667H11.0604C12.4972 13.6667 13.6667 12.4614 13.6667 10.9807V9.99711C13.6667 9.60369 13.3544 9.2818 12.9726 9.2818C12.5909 9.2818 12.2785 9.60369 12.2785 9.99711V10.9807C12.2785 11.6709 11.7337 12.236 11.0604 12.236H2.93966C2.26986 12.236 1.72154 11.6745 1.72154 10.9807V9.99711C1.72154 9.60011 1.41267 9.2818 1.02746 9.2818Z" />
    </svg>
  ),
  EllipsisVertical: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9996 14.3088C13.2741 14.3088 14.3073 13.2756 14.3073 12.0011C14.3073 10.7266 13.2741 9.69336 11.9996 9.69336C10.7251 9.69336 9.69189 10.7266 9.69189 12.0011C9.69189 13.2756 10.7251 14.3088 11.9996 14.3088Z"
        fill="currentColor"
      />
      <path
        d="M11.9996 22.0002C13.2741 22.0002 14.3073 20.967 14.3073 19.6925C14.3073 18.418 13.2741 17.3848 11.9996 17.3848C10.7251 17.3848 9.69189 18.418 9.69189 19.6925C9.69189 20.967 10.7251 22.0002 11.9996 22.0002Z"
        fill="currentColor"
      />
      <path
        d="M11.9996 6.61543C13.2741 6.61543 14.3073 5.58223 14.3073 4.30772C14.3073 3.0332 13.2741 2 11.9996 2C10.7251 2 9.69189 3.0332 9.69189 4.30772C9.69189 5.58223 10.7251 6.61543 11.9996 6.61543Z"
        fill="currentColor"
      />
    </svg>
  ),
  EyeOutline: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.9893 3.69238C5.66976 3.69238 3.29039 5.03489 1.41726 7.71989C1.36379 7.79737 1.33449 7.88897 1.33306 7.9831C1.33163 8.07722 1.35814 8.16966 1.40922 8.24874C2.84845 10.5016 5.19597 12.2634 7.9893 12.2634C10.7523 12.2634 13.148 10.4963 14.5899 8.23832C14.6398 8.1608 14.6663 8.07055 14.6663 7.97836C14.6663 7.88617 14.6398 7.79593 14.5899 7.7184C13.1447 5.48635 10.7314 3.69238 7.9893 3.69238Z"
        stroke="currentColor"
        strokeWidth="1.07"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99901 10.3592C9.31392 10.3592 10.3799 9.29329 10.3799 7.97839C10.3799 6.66348 9.31392 5.59753 7.99901 5.59753C6.68411 5.59753 5.61816 6.66348 5.61816 7.97839C5.61816 9.29329 6.68411 10.3592 7.99901 10.3592Z"
        stroke="currentColor"
        strokeWidth="1.07"
        strokeMiterlimit="10"
      />
    </svg>
  ),
  FilterVertical: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1035 12.6601V2H17.4624V12.6598C19.0987 12.9763 20.3333 14.4161 20.3333 16.1459C20.3333 18.1066 18.7447 19.6951 16.7838 19.6951C14.8218 19.6951 13.2343 18.1071 13.2343 16.1459C13.2343 14.4162 14.4673 12.9771 16.1035 12.6601ZM16.7838 19.7455C16.5491 19.7455 16.3229 19.7181 16.1035 19.6753V21.9992H17.4624V19.6753C17.2447 19.7181 17.0168 19.7455 16.7838 19.7455ZM16.7837 18.3346C17.9931 18.3346 18.9726 17.3552 18.9726 16.146C18.9726 14.9352 17.9933 13.9556 16.7837 13.9556C15.5731 13.9556 14.5948 14.9345 14.5948 16.146C14.5948 17.3559 15.5733 18.3346 16.7837 18.3346ZM7.89648 5.06506V2H6.53587V5.06508C4.90048 5.38231 3.66672 6.82164 3.66672 8.55085C3.66672 10.2788 4.90067 11.7177 6.53584 12.0349V22H7.89645V12.0349C9.53169 11.7178 10.7657 10.2789 10.7657 8.55085C10.7657 6.82161 9.53192 5.38226 7.89648 5.06506ZM9.40497 8.55087C9.40497 9.76014 8.42547 10.7395 7.21608 10.7395C6.00669 10.7395 5.02719 9.76014 5.02719 8.55087C5.02719 7.34009 6.00649 6.36049 7.21608 6.36049C8.42567 6.36049 9.40497 7.34009 9.40497 8.55087Z"
        fill="currentColor"
      />
    </svg>
  ),
  FilterVerticalOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.4444 10L6.4444 21"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.5556 12.5555L17.5556 1.99999"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6.4444 2L6.4444 4.22222"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.5556 21L17.5556 18.7778"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <circle
        cx="6.5"
        cy="6.72198"
        r="2.5"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <circle
        cx="17.5"
        cy="15.5947"
        r="2.5"
        transform="rotate(-180 17.5 15.5947)"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    </svg>
  ),
  HeartOutline: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.3648 2C9.11073 2 7.99968 4.2221 7.99968 4.2221C7.99968 4.2221 6.88863 2 4.63458 2C2.80273 2 1.35211 3.53256 1.33336 5.36128C1.29517 9.15726 4.34466 11.8568 7.68719 14.1254C7.77934 14.1881 7.88822 14.2216 7.99968 14.2216C8.11113 14.2216 8.22001 14.1881 8.31216 14.1254C11.6543 11.8568 14.7038 9.15726 14.666 5.36128C14.6472 3.53256 13.1966 2 11.3648 2V2Z"
        stroke="currentColor"
        strokeWidth="1.07"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  InformationCircle: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9995 2C6.48578 2 2 6.48578 2 11.9995C2 17.5132 6.48578 21.999 11.9995 21.999C17.5132 21.999 21.999 17.5132 21.999 11.9995C21.999 6.48578 17.5132 2 11.9995 2ZM11.9995 6.0998C12.2566 6.0998 12.5079 6.17604 12.7217 6.31888C12.9355 6.46172 13.1021 6.66474 13.2005 6.90227C13.2989 7.1398 13.3246 7.40118 13.2745 7.65334C13.2243 7.9055 13.1005 8.13713 12.9187 8.31893C12.7369 8.50073 12.5053 8.62454 12.2531 8.67469C12.001 8.72485 11.7396 8.69911 11.502 8.60072C11.2645 8.50233 11.0615 8.33572 10.9187 8.12194C10.7758 7.90817 10.6996 7.65684 10.6996 7.39974C10.6996 7.05497 10.8365 6.72433 11.0803 6.48054C11.3241 6.23676 11.6547 6.0998 11.9995 6.0998ZM14.3994 17.3992H9.99961C9.78745 17.3992 9.58397 17.315 9.43395 17.1649C9.28393 17.0149 9.19965 16.8114 9.19965 16.5993C9.19965 16.3871 9.28393 16.1837 9.43395 16.0336C9.58397 15.8836 9.78745 15.7993 9.99961 15.7993H11.3995V11.3995H10.5996C10.3874 11.3995 10.1839 11.3153 10.0339 11.1652C9.8839 11.0152 9.79962 10.8117 9.79962 10.5996C9.79962 10.3874 9.8839 10.1839 10.0339 10.0339C10.1839 9.8839 10.3874 9.79962 10.5996 9.79962H12.1995C12.4117 9.79962 12.6151 9.8839 12.7652 10.0339C12.9152 10.1839 12.9995 10.3874 12.9995 10.5996V15.7993H14.3994C14.6116 15.7993 14.815 15.8836 14.9651 16.0336C15.1151 16.1837 15.1994 16.3871 15.1994 16.5993C15.1994 16.8114 15.1151 17.0149 14.9651 17.1649C14.815 17.315 14.6116 17.3992 14.3994 17.3992Z"
        fill="currentColor"
      />
    </svg>
  ),
  InformationCircleOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.47772 2 2 6.47772 2 12C2 17.5223 6.47772 22 12 22C17.5223 22 22 17.5223 22 12C22 6.47772 17.5223 2 12 2Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M10.479 10.4796H12.2181V16.784"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.82666 17.0016H14.6093"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12.0002 5.58813C11.7207 5.58813 11.4475 5.67101 11.2152 5.82628C10.9828 5.98154 10.8017 6.20223 10.6947 6.46043C10.5878 6.71863 10.5598 7.00275 10.6143 7.27685C10.6688 7.55095 10.8034 7.80273 11.001 8.00035C11.1986 8.19797 11.4504 8.33255 11.7245 8.38707C11.9986 8.44159 12.2828 8.41361 12.541 8.30666C12.7992 8.19971 13.0198 8.0186 13.1751 7.78622C13.3304 7.55385 13.4132 7.28065 13.4132 7.00118C13.4132 6.62642 13.2644 6.267 12.9994 6.00201C12.7344 5.73701 12.375 5.58813 12.0002 5.58813Z"
        fill="currentColor"
      />
    </svg>
  ),
  Menu: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 17.9302C2 17.4165 2.41648 17 2.93023 17H21.0698C21.5835 17 22 17.4165 22 17.9302C22 18.444 21.5835 18.8605 21.0698 18.8605H2.93023C2.41648 18.8605 2 18.444 2 17.9302Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 11.9302C2 11.4165 2.41648 11 2.93023 11H21.0698C21.5835 11 22 11.4165 22 11.9302C22 12.444 21.5835 12.8605 21.0698 12.8605H2.93023C2.41648 12.8605 2 12.444 2 11.9302Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5.93023C2 5.41648 2.41648 5 2.93023 5H21.0698C21.5835 5 22 5.41648 22 5.93023C22 6.44399 21.5835 6.86047 21.0698 6.86047H2.93023C2.41648 6.86047 2 6.44399 2 5.93023Z"
        fill="currentColor"
      />
    </svg>
  ),
  MenuOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 18.1538H22" stroke="currentColor" strokeWidth="1.6" />
      <path d="M2 12H22" stroke="currentColor" strokeWidth="1.6" />
      <path d="M2 5.84613H22" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  ),
  OpenNewTab: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6667 9.94052V19.7924C18.6667 21.0207 17.6709 22.0164 16.4426 22.0164H4.22408C2.99575 22.0164 2 21.0207 2 19.7924V7.52044C2 6.29211 2.99575 5.29636 4.22408 5.29636H13.1111"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3295 13.6461L21.893 2.08258"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M16.136 1.98328H22.0001V7.83946"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Pencil: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6836 5.88852L2.7819 16.9287L2 22L7.16665 21.4567L18.1115 10.3729L13.6836 5.88852Z"
        fill="currentColor"
      />
      <path
        d="M16.8893 2.47038L14.7784 4.58124L19.4196 9.22238L21.5304 7.11152C21.7902 6.85174 21.7902 6.43055 21.5304 6.17076L17.8301 2.47038C17.5703 2.2106 17.1491 2.2106 16.8893 2.47038Z"
        fill="currentColor"
      />
    </svg>
  ),
  PencilOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7193 6.57864L2.79279 16.857L2 21.9989L7.23858 21.448L17.2088 11.1254L12.7193 6.57864Z"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M17.0965 2.19755L14.9563 4.33779L19.6621 9.04354L21.8023 6.9033C22.0657 6.6399 22.0657 6.21284 21.8023 5.94944L18.0504 2.19755C17.787 1.93415 17.3599 1.93415 17.0965 2.19755Z"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    </svg>
  ),
  PersonCircle: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0002 2C6.4863 2 2.00024 6.48606 2.00024 12C2.00024 17.5139 6.4863 22 12.0002 22C17.5142 22 22.0002 17.5139 22.0002 12C22.0002 6.48606 17.5142 2 12.0002 2ZM9.58582 7.61635C10.195 6.97067 11.0522 6.61538 12.0002 6.61538C12.9483 6.61538 13.7978 6.97308 14.4094 7.62212C15.0291 8.27981 15.3305 9.16346 15.2594 10.1135C15.1171 12 13.6555 13.5385 12.0002 13.5385C10.345 13.5385 8.88053 12 8.74111 10.113C8.67044 9.15529 8.9714 8.26875 9.58582 7.61635ZM12.0002 20.4615C10.8707 20.4623 9.75243 20.2362 8.71186 19.7967C7.67129 19.3572 6.72957 18.7132 5.94255 17.9029C6.3933 17.2601 6.96763 16.7135 7.63198 16.2952C8.85746 15.5096 10.4084 15.0769 12.0002 15.0769C13.5921 15.0769 15.143 15.5096 16.3671 16.2952C17.032 16.7133 17.6068 17.2599 18.0579 17.9029C17.271 18.7133 16.3293 19.3573 15.2887 19.7968C14.2481 20.2364 13.1298 20.4624 12.0002 20.4615Z"
        fill="currentColor"
      />
    </svg>
  ),
  PersonCircleOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.00081 12.1394C1.92485 6.51589 6.51577 1.92497 12.1393 2.00093C17.5325 2.07592 21.9239 6.46734 21.998 11.8615C22.0749 17.485 17.4849 22.076 11.8605 21.999C6.46722 21.9241 2.0758 17.5326 2.00081 12.1394ZM18.1478 17.7802C18.174 17.7696 18.1974 17.7533 18.2166 17.7326C19.6607 16.1731 20.4622 14.1255 20.4606 12C20.4606 7.32783 16.659 3.52771 11.9792 3.53925C7.29935 3.55078 3.46077 7.46628 3.53912 12.1442C3.57349 14.2196 4.37254 16.2094 5.78314 17.7321C5.80229 17.7528 5.82576 17.7691 5.85189 17.7797C5.87802 17.7903 5.90616 17.7951 5.93433 17.7936C5.9625 17.7921 5.99 17.7845 6.01488 17.7712C6.03976 17.7579 6.06142 17.7393 6.07831 17.7168C6.50831 17.1543 7.03489 16.6729 7.63345 16.2948C8.85738 15.5093 10.4082 15.0766 11.9999 15.0766C13.5915 15.0766 15.1424 15.5093 16.3663 16.2948C16.9649 16.673 17.4914 17.1547 17.9214 17.7172C17.9383 17.7398 17.96 17.7584 17.9849 17.7717C18.0097 17.785 18.0372 17.7926 18.0654 17.7941C18.0936 17.7956 18.1217 17.7908 18.1478 17.7802ZM9.58563 7.61622C10.1947 6.97061 11.0518 6.61536 11.9998 6.61536C12.9416 6.61536 13.7973 6.97302 14.4087 7.62199C15.0279 8.27962 15.3298 9.16416 15.2587 10.1131C15.1164 11.9995 13.6574 13.5378 11.9998 13.5378C10.3423 13.5378 8.88041 11.9995 8.741 10.1126C8.67226 9.15454 8.97655 8.26184 9.58563 7.61622Z"
        fill="currentColor"
      />
    </svg>
  ),
  Play: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.31557 22C4.98189 21.9994 4.65411 21.9119 4.36449 21.7462C3.71232 21.3766 3.30688 20.6592 3.30688 19.8804V4.11965C3.30688 3.33868 3.71232 2.62346 4.36449 2.2539C4.66101 2.08348 4.99786 1.99585 5.33984 2.00015C5.68182 2.00445 6.01636 2.10054 6.3085 2.27836L19.7785 10.3414C20.0593 10.5174 20.2907 10.7618 20.4511 11.0518C20.6115 11.3417 20.6957 11.6676 20.6957 11.999C20.6957 12.3303 20.6115 12.6562 20.4511 12.9462C20.2907 13.2361 20.0593 13.4805 19.7785 13.6566L6.30633 21.7217C6.00736 21.9025 5.66493 21.9987 5.31557 22Z"
        fill="currentColor"
      />
    </svg>
  ),
  PlayOutline: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.66699 2.86716V13.7995C2.66699 14.457 3.30785 14.8746 3.83562 14.5595L13.1809 8.96628C13.6378 8.69297 13.6378 7.9737 13.1809 7.70039L3.83562 2.10717C3.30785 1.79202 2.66699 2.20971 2.66699 2.86716Z"
        stroke="currentColor"
        strokeWidth="1.19705"
        strokeMiterlimit="10"
      />
    </svg>
  ),
  PauseOutline: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="ionicon"
      viewBox="0 0 512 512"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M176 96h16v320h-16zM320 96h16v320h-16z"
      />
    </svg>
  ),
  VolumeHighOutline: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="ionicon"
      viewBox="0 0 512 512"
    >
      <path
        d="M126 192H56a8 8 0 00-8 8v112a8 8 0 008 8h69.65a15.93 15.93 0 0110.14 3.54l91.47 74.89A8 8 0 00240 392V120a8 8 0 00-12.74-6.43l-91.47 74.89A15 15 0 01126 192zM320 320c9.74-19.38 16-40.84 16-64 0-23.48-6-44.42-16-64M368 368c19.48-33.92 32-64.06 32-112s-12-77.74-32-112M416 416c30-46 48-91.43 48-160s-18-113-48-160"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
      />
    </svg>
  ),
  VolumeMuteOutline: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="ionicon"
      viewBox="0 0 512 512"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="32"
        d="M416 432L64 80"
      />
      <path
        fill="currentColor"
        d="M224 136.92v33.8a4 4 0 001.17 2.82l24 24a4 4 0 006.83-2.82v-74.15a24.53 24.53 0 00-12.67-21.72 23.91 23.91 0 00-25.55 1.83 8.27 8.27 0 00-.66.51l-31.94 26.15a4 4 0 00-.29 5.92l17.05 17.06a4 4 0 005.37.26zM224 375.08l-78.07-63.92a32 32 0 00-20.28-7.16H64v-96h50.72a4 4 0 002.82-6.83l-24-24a4 4 0 00-2.82-1.17H56a24 24 0 00-24 24v112a24 24 0 0024 24h69.76l91.36 74.8a8.27 8.27 0 00.66.51 23.93 23.93 0 0025.85 1.69A24.49 24.49 0 00256 391.45v-50.17a4 4 0 00-1.17-2.82l-24-24a4 4 0 00-6.83 2.82zM125.82 336zM352 256c0-24.56-5.81-47.88-17.75-71.27a16 16 0 00-28.5 14.54C315.34 218.06 320 236.62 320 256q0 4-.31 8.13a8 8 0 002.32 6.25l19.66 19.67a4 4 0 006.75-2A146.89 146.89 0 00352 256zM416 256c0-51.19-13.08-83.89-34.18-120.06a16 16 0 00-27.64 16.12C373.07 184.44 384 211.83 384 256c0 23.83-3.29 42.88-9.37 60.65a8 8 0 001.9 8.26l16.77 16.76a4 4 0 006.52-1.27C410.09 315.88 416 289.91 416 256z"
      />
      <path
        fill="currentColor"
        d="M480 256c0-74.26-20.19-121.11-50.51-168.61a16 16 0 10-27 17.22C429.82 147.38 448 189.5 448 256c0 47.45-8.9 82.12-23.59 113a4 4 0 00.77 4.55L443 391.39a4 4 0 006.4-1C470.88 348.22 480 307 480 256z"
      />
    </svg>
  ),
  Refresh: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5251 2.21744C12.2352 1.92752 11.7652 1.92752 11.4753 2.21744C11.1853 2.50735 11.1853 2.97739 11.4753 3.26731L13.8107 5.60274C13.3467 5.57113 12.7545 5.55275 12.0001 5.55275C10.3736 5.55275 8.78366 6.03505 7.43129 6.93868C6.07892 7.8423 5.02488 9.12665 4.40245 10.6293C3.78002 12.132 3.61717 13.7855 3.93448 15.3807C4.25179 16.9759 5.03501 18.4413 6.18511 19.5914C7.3352 20.7414 8.80051 21.5247 10.3957 21.842C11.991 22.1593 13.6445 21.9964 15.1471 21.374C16.6498 20.7516 17.9342 19.6975 18.8378 18.3452C19.7414 16.9928 20.2237 15.4029 20.2237 13.7764C20.2237 13.3664 19.8913 13.034 19.4813 13.034C19.0713 13.034 18.739 13.3664 18.739 13.7764C18.739 15.1092 18.3437 16.4121 17.6033 17.5203C16.8628 18.6285 15.8103 19.4922 14.5789 20.0023C13.3476 20.5123 11.9926 20.6458 10.6854 20.3858C9.37818 20.1257 8.17743 19.4839 7.23498 18.5415C6.29253 17.599 5.65071 16.3983 5.39069 15.0911C5.13067 13.7838 5.26412 12.4289 5.77417 11.1975C6.28422 9.96614 7.14796 8.91367 8.25617 8.17319C9.36437 7.43272 10.6673 7.03749 12.0001 7.03749C12.9684 7.03749 13.6239 7.06886 14.0606 7.11338L11.4753 9.69869C11.1853 9.9886 11.1853 10.4586 11.4753 10.7486C11.7652 11.0385 12.2352 11.0385 12.5251 10.7486L16.2657 7.00793C16.405 6.86871 16.4832 6.67989 16.4832 6.483C16.4832 6.28611 16.405 6.09728 16.2657 5.95806L12.5251 2.21744Z"
        fill="currentColor"
      />
    </svg>
  ),
  RefreshOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2319 6.44432C15.2319 6.44432 16.462 5.83838 12.0002 5.83838C10.4023 5.83838 8.84031 6.31221 7.5117 7.19996C6.18309 8.08771 5.14757 9.3495 4.53607 10.8258C3.92458 12.302 3.76459 13.9265 4.07632 15.4937C4.38806 17.0609 5.15753 18.5005 6.28742 19.6304C7.41731 20.7603 8.85687 21.5297 10.4241 21.8415C11.9913 22.1532 13.6157 21.9932 15.092 21.3817C16.5683 20.7702 17.8301 19.7347 18.7178 18.4061C19.6056 17.0775 20.0794 15.5154 20.0794 13.9175"
        stroke="currentColor"
        strokeWidth="1.6034"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12 2L16.0395 6.03958L12 10.0792"
        stroke="currentColor"
        strokeWidth="1.6034"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Remove: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 11.5582 2.38513 11.2 2.86022 11.2L21.1398 11.2C21.6149 11.2 22 11.5582 22 12C22 12.4418 21.6149 12.8 21.1398 12.8L2.86021 12.8C2.38513 12.8 2 12.4418 2 12Z"
        fill="currentColor"
      />
    </svg>
  ),
  RemoveOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12L2 12"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Search: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6935 19.9925L17.1596 15.4586C18.2511 14.0054 18.8404 12.2367 18.8384 10.4192C18.8384 5.77688 15.0615 2 10.4192 2C5.77688 2 2 5.77688 2 10.4192C2 15.0615 5.77688 18.8384 10.4192 18.8384C12.2367 18.8404 14.0054 18.2511 15.4586 17.1596L19.9925 21.6935C20.222 21.8986 20.5213 22.0081 20.829 21.9995C21.1367 21.9909 21.4295 21.8648 21.6472 21.6472C21.8648 21.4295 21.9909 21.1367 21.9995 20.829C22.0081 20.5213 21.8986 20.222 21.6935 19.9925ZM4.40549 10.4192C4.40549 9.2298 4.75818 8.06711 5.41898 7.07816C6.07977 6.08921 7.01899 5.31842 8.11785 4.86325C9.21671 4.40809 10.4259 4.289 11.5924 4.52104C12.759 4.75308 13.8305 5.32583 14.6715 6.16686C15.5126 7.00789 16.0853 8.07944 16.3174 9.24598C16.5494 10.4125 16.4303 11.6217 15.9751 12.7205C15.52 13.8194 14.7492 14.7586 13.7602 15.4194C12.7713 16.0802 11.6086 16.4329 10.4192 16.4329C8.82485 16.431 7.29635 15.7968 6.16897 14.6694C5.0416 13.5421 4.4074 12.0135 4.40549 10.4192Z"
        fill="currentColor"
      />
    </svg>
  ),
  SearchOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1817 1.20001C8.40525 1.20001 6.66873 1.72678 5.1917 2.7137C3.71466 3.70063 2.56345 5.10338 1.88365 6.74457C1.20384 8.38576 1.02597 10.1917 1.37254 11.934C1.7191 13.6762 2.57452 15.2766 3.83064 16.5328C5.08675 17.7889 6.68714 18.6443 8.42942 18.9909C10.1717 19.3374 11.9776 19.1595 13.6188 18.4797C14.4645 18.1294 15.2469 17.654 15.9417 17.0733L21.4342 22.5657C21.7466 22.8781 22.2531 22.8781 22.5655 22.5657C22.878 22.2533 22.878 21.7468 22.5655 21.4344L17.0731 15.9419C17.2782 15.6964 17.4708 15.4394 17.6497 15.1717C18.6366 13.6947 19.1634 11.9581 19.1634 10.1817V10.1817C19.1632 7.79963 18.2169 5.5152 16.5325 3.83085C14.8482 2.14649 12.5638 1.20016 10.1817 1.20001L10.1817 2.00749V1.20001ZM15.4012 4.96222C14.0169 3.57791 12.1394 2.80015 10.1817 2.80001L17.5634 10.1817C17.5632 8.22401 16.7855 6.34653 15.4012 4.96222ZM6.08061 4.04405C7.29451 3.23295 8.72167 2.80002 10.1816 2.80001L17.5634 10.1818C17.5634 11.6417 17.1304 13.0689 16.3193 14.2828C15.5082 15.4967 14.3554 16.4428 13.0065 17.0015C11.6577 17.5602 10.1735 17.7064 8.74157 17.4216C7.30965 17.1368 5.99436 16.4337 4.96201 15.4014C3.92966 14.369 3.22662 13.0537 2.94179 11.6218C2.65697 10.1899 2.80315 8.7057 3.36185 7.35686C3.92056 6.00803 4.86669 4.85517 6.08061 4.04405Z"
        fill="currentColor"
      />
    </svg>
  ),
  Sparkle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1607_22666)">
        <path
          d="M8.1225 8.21594L6.7625 4.68031C6.74209 4.62725 6.70608 4.58163 6.65922 4.54944C6.61236 4.51726 6.55685 4.50003 6.5 4.50003C6.44315 4.50003 6.38764 4.51726 6.34078 4.54944C6.29392 4.58163 6.25791 4.62725 6.2375 4.68031L4.8775 8.21594C4.86337 8.25267 4.84169 8.28603 4.81386 8.31386C4.78603 8.34169 4.75267 8.36337 4.71594 8.3775L1.18031 9.7375C1.12725 9.75791 1.08163 9.79392 1.04944 9.84078C1.01726 9.88764 1.00003 9.94315 1.00003 10C1.00003 10.0568 1.01726 10.1124 1.04944 10.1592C1.08163 10.2061 1.12725 10.2421 1.18031 10.2625L4.71594 11.6225C4.75267 11.6366 4.78603 11.6583 4.81386 11.6861C4.84169 11.714 4.86337 11.7473 4.8775 11.7841L6.2375 15.3197C6.25791 15.3727 6.29392 15.4184 6.34078 15.4506C6.38764 15.4827 6.44315 15.5 6.5 15.5C6.55685 15.5 6.61236 15.4827 6.65922 15.4506C6.70608 15.4184 6.74209 15.3727 6.7625 15.3197L8.1225 11.7841C8.13663 11.7473 8.15831 11.714 8.18614 11.6861C8.21397 11.6583 8.24733 11.6366 8.28406 11.6225L11.8197 10.2625C11.8727 10.2421 11.9184 10.2061 11.9506 10.1592C11.9827 10.1124 12 10.0568 12 10C12 9.94315 11.9827 9.88764 11.9506 9.84078C11.9184 9.79392 11.8727 9.75791 11.8197 9.7375L8.28406 8.3775C8.24733 8.36337 8.21397 8.34169 8.18614 8.31386C8.15831 8.28603 8.13663 8.25267 8.1225 8.21594ZM3.375 2.125L2.75 0.5L2.125 2.125L0.5 2.75L2.125 3.375L2.75 5L3.375 3.375L5 2.75L3.375 2.125ZM13.3334 3.66656L12.5 1.5L11.6666 3.66656L9.5 4.5L11.6666 5.33344L12.5 7.5L13.3334 5.33344L15.5 4.5L13.3334 3.66656Z"
          stroke="currentColor"
          strokeWidth="1.07"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1607_22666">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  ),
  SpeechBubbleOutline: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1607_23874)">
        <path
          d="M2.59874 11.9744C2.63689 11.834 2.55259 11.6388 2.47214 11.4981C2.44709 11.4561 2.41992 11.4155 2.39073 11.3763C1.70075 10.3299 1.333 9.10405 1.33304 7.85065C1.32182 4.25289 4.30515 1.33334 7.99426 1.33334C11.2116 1.33334 13.8971 3.56219 14.5247 6.52084C14.6187 6.9595 14.6662 7.40684 14.6664 7.85546C14.6664 11.4583 11.7981 14.4237 8.109 14.4237C7.52246 14.4237 6.7308 14.2763 6.29907 14.1555C5.86733 14.0346 5.43624 13.8744 5.32503 13.8314C5.21128 13.7877 5.09048 13.7652 4.96862 13.7651C4.83551 13.7646 4.70369 13.7911 4.58112 13.843L2.40708 14.6276C2.35945 14.6481 2.30898 14.6613 2.2574 14.6667C2.21669 14.6666 2.17642 14.6584 2.1389 14.6426C2.10139 14.6268 2.06738 14.6037 2.03885 14.5746C2.01032 14.5456 1.98784 14.5112 1.9727 14.4734C1.95756 14.4356 1.95007 14.3952 1.95067 14.3545C1.95334 14.3188 1.95979 14.2834 1.9699 14.249L2.59874 11.9744Z"
          stroke="currentColor"
          strokeWidth="1.07"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1607_23874">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Spinner: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C10.8954 24 10 23.1046 10 22C10 20.8954 10.8954 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.1046 3.10457 14 2 14C0.89543 14 0 13.1046 0 12Z"
        fill="url(#paint0_linear_1_19)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_19"
          x1="2"
          y1="12"
          x2="22"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" stopOpacity="0.12" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
      </defs>
    </svg>
  ),
  Spotlight: (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.44336 12.5467H18.7763"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.74108 13.2876C2.15037 13.2876 2.48216 12.9558 2.48216 12.5465C2.48216 12.1372 2.15037 11.8054 1.74108 11.8054C1.33179 11.8054 1 12.1372 1 12.5465C1 12.9558 1.33179 13.2876 1.74108 13.2876Z"
        stroke="currentColor"
        strokeWidth="1.4222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44336 7.36101H9.88775"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.74108 7.95429C2.15037 7.95429 2.48216 7.6225 2.48216 7.21321C2.48216 6.80392 2.15037 6.47213 1.74108 6.47213C1.33179 6.47213 1 6.80392 1 7.21321C1 7.6225 1.33179 7.95429 1.74108 7.95429Z"
        stroke="currentColor"
        strokeWidth="1.4222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44336 17.88H18.7763"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.74108 18.4697C2.15037 18.4697 2.48216 18.1379 2.48216 17.7286C2.48216 17.3194 2.15037 16.9876 1.74108 16.9876C1.33179 16.9876 1 17.3194 1 17.7286C1 18.1379 1.33179 18.4697 1.74108 18.4697Z"
        stroke="currentColor"
        strokeWidth="1.4222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2481 3.83911H16.2531L15.3477 1.05311L14.4422 3.83911H11.4473L13.885 5.51071L12.9447 8.29671L15.3477 6.55546L17.7506 8.29671L16.8103 5.51071L19.2481 3.83911Z"
        stroke="currentColor"
        strokeWidth="0.881031"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Star: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7494 21.3286C17.609 21.3292 17.4721 21.2854 17.3581 21.2036L11.999 17.3183L6.63983 21.2036C6.52533 21.2867 6.3874 21.3311 6.24596 21.3306C6.10452 21.3301 5.96691 21.2846 5.85302 21.2008C5.73913 21.1169 5.65487 20.999 5.61241 20.8641C5.56996 20.7291 5.57151 20.5842 5.61684 20.4502L7.70699 14.2594L2.28994 10.5445C2.1726 10.4642 2.08404 10.3484 2.0372 10.2141C1.99036 10.0798 1.98769 9.93403 2.02958 9.79811C2.07147 9.6622 2.15573 9.54324 2.27004 9.45862C2.38436 9.374 2.52274 9.32815 2.66496 9.32778H9.34794L11.3647 3.12109C11.4082 2.98709 11.493 2.87029 11.6069 2.78746C11.7208 2.70462 11.8581 2.66 11.999 2.66C12.1398 2.66 12.2771 2.70462 12.391 2.78746C12.505 2.87029 12.5897 2.98709 12.6332 3.12109L14.65 9.32986H21.333C21.4754 9.32979 21.614 9.37532 21.7287 9.45978C21.8434 9.54423 21.928 9.66318 21.9701 9.7992C22.0123 9.93522 22.0098 10.0812 21.963 10.2157C21.9162 10.3502 21.8275 10.4661 21.7101 10.5466L16.2909 14.2594L18.3798 20.4486C18.4137 20.5488 18.4232 20.6556 18.4076 20.7602C18.392 20.8648 18.3518 20.9642 18.2902 21.0502C18.2286 21.1362 18.1474 21.2063 18.0534 21.2547C17.9593 21.3031 17.8551 21.3284 17.7494 21.3286Z"
        fill="currentColor"
      />
    </svg>
  ),
  StarOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 9.84287H14.3214L12 2.70001L9.67857 9.84287H2L8.25 14.1286L5.83929 21.2714L12 16.8072L18.1607 21.2714L15.75 14.1286L22 9.84287Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Trash: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8571 4.85714H15.5714V3.78571C15.5714 3.31211 15.3832 2.85791 15.0484 2.52302C14.7135 2.18814 14.2593 2 13.7857 2H10.2142C9.74064 2 9.28644 2.18814 8.95155 2.52302C8.61666 2.85791 8.42853 3.31211 8.42853 3.78571V4.85714H4.14281C3.95337 4.85714 3.77169 4.9324 3.63774 5.06635C3.50378 5.20031 3.42853 5.38199 3.42853 5.57143C3.42853 5.76087 3.50378 5.94255 3.63774 6.0765C3.77169 6.21046 3.95337 6.28571 4.14281 6.28571H4.90174L5.74996 19.8982C5.81335 21.0969 6.7321 22 7.89281 22H16.1071C17.2736 22 18.1741 21.117 18.25 19.9018L19.0982 6.28571H19.8571C20.0465 6.28571 20.2282 6.21046 20.3622 6.0765C20.4961 5.94255 20.5714 5.76087 20.5714 5.57143C20.5714 5.38199 20.4961 5.20031 20.3622 5.06635C20.2282 4.9324 20.0465 4.85714 19.8571 4.85714ZM9.16826 19.1429H9.14281C8.9577 19.143 8.77977 19.0712 8.64653 18.9427C8.51328 18.8142 8.43512 18.639 8.42853 18.454L8.07138 8.45402C8.06464 8.26458 8.13342 8.08021 8.2626 7.94149C8.39178 7.80276 8.57078 7.72103 8.76022 7.71429C8.94966 7.70754 9.13403 7.77632 9.27275 7.9055C9.41148 8.03468 9.49321 8.21368 9.49996 8.40312L9.8571 18.4031C9.8605 18.4969 9.84538 18.5905 9.81259 18.6785C9.7798 18.7664 9.73 18.8471 9.66602 18.9158C9.60204 18.9845 9.52515 19.0399 9.43974 19.0789C9.35433 19.1178 9.26208 19.1396 9.16826 19.1429ZM12.7142 18.4286C12.7142 18.618 12.639 18.7997 12.505 18.9336C12.3711 19.0676 12.1894 19.1429 12 19.1429C11.8105 19.1429 11.6288 19.0676 11.4949 18.9336C11.3609 18.7997 11.2857 18.618 11.2857 18.4286V8.42857C11.2857 8.23913 11.3609 8.05745 11.4949 7.9235C11.6288 7.78954 11.8105 7.71429 12 7.71429C12.1894 7.71429 12.3711 7.78954 12.505 7.9235C12.639 8.05745 12.7142 8.23913 12.7142 8.42857V18.4286ZM14.1428 4.85714H9.8571V3.78571C9.85656 3.73866 9.86543 3.69198 9.88319 3.64841C9.90095 3.60483 9.92723 3.56525 9.9605 3.53198C9.99377 3.4987 10.0334 3.47242 10.0769 3.45466C10.1205 3.4369 10.1672 3.42803 10.2142 3.42857H13.7857C13.8327 3.42803 13.8794 3.4369 13.923 3.45466C13.9666 3.47242 14.0061 3.4987 14.0394 3.53198C14.0727 3.56525 14.099 3.60483 14.1167 3.64841C14.1345 3.69198 14.1434 3.73866 14.1428 3.78571V4.85714ZM15.5714 18.454C15.5648 18.639 15.4866 18.8142 15.3534 18.9427C15.2201 19.0712 15.0422 19.143 14.8571 19.1429H14.8312C14.7374 19.1395 14.6452 19.1177 14.5599 19.0787C14.4745 19.0398 14.3977 18.9843 14.3337 18.9156C14.2698 18.8469 14.22 18.7663 14.1873 18.6784C14.1545 18.5904 14.1394 18.4969 14.1428 18.4031L14.5 8.40312C14.5033 8.30932 14.5251 8.2171 14.5641 8.13172C14.6031 8.04633 14.6585 7.96947 14.7272 7.9055C14.7958 7.84154 14.8765 7.79173 14.9644 7.75892C15.0523 7.72611 15.1459 7.71094 15.2397 7.71429C15.3335 7.71763 15.4257 7.73941 15.5111 7.7784C15.5965 7.81738 15.6733 7.8728 15.7373 7.94149C15.8013 8.01018 15.8511 8.0908 15.8839 8.17874C15.9167 8.26667 15.9319 8.36022 15.9285 8.45402L15.5714 18.454Z"
        fill="currentColor"
      />
    </svg>
  ),
  TrashOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.07721 5.07748L6.03872 20.4616C6.08439 21.3505 6.731 22 7.57713 22H16.423C17.2725 22 17.9071 21.3505 17.9614 20.4616L18.9229 5.07748"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.53784 5.07748H20.4604H3.53784Z" fill="currentColor" />
      <path
        d="M3.53784 5.07748H20.4604"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.4612 8.15365L15.0766 18.9225M8.92296 5.07683V3.15381C8.92252 3.00217 8.95206 2.85193 9.00989 2.71175C9.06771 2.57156 9.15269 2.44419 9.25992 2.33696C9.36715 2.22973 9.49452 2.14476 9.6347 2.08693C9.77489 2.0291 9.92513 1.99956 10.0768 2H13.9228C14.0744 1.99956 14.2247 2.0291 14.3649 2.08693C14.5051 2.14476 14.6324 2.22973 14.7397 2.33696C14.8469 2.44419 14.9319 2.57156 14.9897 2.71175C15.0475 2.85193 15.0771 3.00217 15.0766 3.15381V5.07683H8.92296ZM11.9998 8.15365V18.9225V8.15365ZM8.53836 8.15365L8.92296 18.9225L8.53836 8.15365Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  UploadCloud: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5024 10.3362C19.9556 9.93077 19.2837 9.63311 18.5743 9.47256C18.4578 9.44636 18.3512 9.38757 18.2669 9.30304C18.1826 9.21852 18.1241 9.11176 18.0981 8.99522C17.7935 7.6378 17.1376 6.47374 16.1735 5.5917C15.0528 4.56475 13.5708 3.99991 12.0001 3.99991C10.6192 3.99991 9.34384 4.43272 8.31376 5.25186C7.61565 5.8079 7.05371 6.516 6.67079 7.32217C6.62928 7.41038 6.56771 7.48765 6.49099 7.54782C6.41428 7.60798 6.32456 7.64936 6.229 7.66866C5.18408 7.8796 4.24072 8.32764 3.5204 8.96241C2.52587 9.84131 2.00009 11.0097 2.00009 12.3437C2.00009 13.6921 2.56611 14.9218 3.59345 15.8108C4.5747 16.6581 5.89579 17.1249 7.31259 17.1249H11.3751V11.1339L9.94189 12.5671C9.88205 12.6269 9.81069 12.674 9.73213 12.7054C9.65357 12.7368 9.56945 12.752 9.48486 12.7499C9.40027 12.7479 9.31697 12.7287 9.24003 12.6935C9.16308 12.6583 9.09407 12.6079 9.0372 12.5452C8.81064 12.2964 8.83251 11.9085 9.0704 11.6706L11.5583 9.18311C11.6755 9.06599 11.8344 9.0002 12.0001 9.0002C12.1658 9.0002 12.3247 9.06599 12.4419 9.18311L14.9298 11.6698C15.1751 11.9155 15.1892 12.3183 14.945 12.5647C14.8871 12.6232 14.8182 12.6697 14.7423 12.7015C14.6663 12.7333 14.5849 12.7498 14.5025 12.75C14.4202 12.7502 14.3387 12.7342 14.2626 12.7028C14.1865 12.6714 14.1173 12.6253 14.0591 12.5671L12.6251 11.1339V17.1249H17.4688C18.6931 17.1249 19.8091 16.7812 20.6114 16.1573C21.52 15.4503 22.0001 14.4386 22.0001 13.2343C22.0001 12.0648 21.4821 11.062 20.5024 10.3362ZM11.3751 19.6413C11.3751 19.8071 11.4409 19.966 11.5582 20.0833C11.6754 20.2005 11.8343 20.2663 12.0001 20.2663C12.1659 20.2663 12.3248 20.2005 12.442 20.0833C12.5592 19.966 12.6251 19.8071 12.6251 19.6413V17.1249H11.3751V19.6413Z"
        fill="currentColor"
      />
    </svg>
  ),
  UploadCloudOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8333 15C20.125 15 22 14.1162 22 11.85C22 9.58375 19.7917 8.78875 18 8.7C17.6296 5.15583 15.0417 3 12 3C9.125 3 7.27333 4.90792 6.66667 6.8C4.16667 7.0375 2 8.295 2 10.9C2 13.505 4.25 15 7 15"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4401 12.6626L11.7626 10.011L9.10683 12.6844M11.8036 20.0109L11.7653 10.6764"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SortDesc: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2222 12C17.6935 12 20.8889 12 20.8889 12M13.1111 7.55551H22M15.3333 16.4444H19.7778"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 18.8335V7.16683M5.5 18.8335L2 15.3335M5.5 18.8335L9 15.3335"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SortDescOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2222 12C17.6935 12 20.8889 12 20.8889 12M13.1111 7.55551H22M15.3333 16.4444H19.7778"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 18.8335V7.16683M5.5 18.8335L2 15.3335M5.5 18.8335L9 15.3335"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SortAsc: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3596 12H21.1011M15.2584 7.55551H20.2022M13.4607 16.4444H22M5.37079 6.4444V17.5555M5.37079 6.4444L2 9.77773M5.37079 6.4444L8.74157 9.77773"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SortAscOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3596 12H21.1011M15.2584 7.55551H20.2022M13.4607 16.4444H22M5.37079 6.4444V17.5555M5.37079 6.4444L2 9.77773M5.37079 6.4444L8.74157 9.77773"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Sort: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2222 12C16.6936 12 21.8889 12 21.8889 12M13.1111 7.55551H22M13.3333 16.4444H21.7778M5.33333 6.4444V17.5555M5.33333 6.4444L2 9.77773M5.33333 6.4444L8.66667 9.77773"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 18.8335V7.16683M5.5 18.8335L2 15.3335M5.5 18.8335L9 15.3335"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SortOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2222 12C16.6936 12 21.8889 12 21.8889 12M13.1111 7.55551H22M13.3333 16.4444H21.7778M5.33333 6.4444V17.5555M5.33333 6.4444L2 9.77773M5.33333 6.4444L8.66667 9.77773"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 18.8335V7.16683M5.5 18.8335L2 15.3335M5.5 18.8335L9 15.3335"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  WarningOutline: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.57963 21.7861H20.4087C20.682 21.7861 20.9506 21.7151 21.1883 21.5802C21.426 21.4453 21.6247 21.251 21.7648 21.0163C21.905 20.7816 21.9818 20.5146 21.9879 20.2413C21.994 19.9681 21.9291 19.6979 21.7995 19.4573L13.3855 3.83093C12.7885 2.72302 11.1997 2.72302 10.6028 3.83093L2.18881 19.4573C2.05924 19.6979 1.99431 19.9681 2.00039 20.2413C2.00647 20.5146 2.08333 20.7816 2.22348 21.0163C2.36362 21.251 2.56225 21.4453 2.79995 21.5802C3.03765 21.7151 3.3063 21.7861 3.57963 21.7861Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7104 9.40045L11.9938 15.4242L12.2767 9.40292C12.2785 9.36443 12.2724 9.32598 12.2587 9.28994C12.2451 9.25389 12.2243 9.221 12.1975 9.19327C12.1708 9.16554 12.1387 9.14356 12.1031 9.12867C12.0676 9.11378 12.0294 9.1063 11.9908 9.10667C11.953 9.10704 11.9156 9.11499 11.8809 9.13006C11.8461 9.14512 11.8148 9.16699 11.7886 9.19437C11.7625 9.22176 11.7421 9.2541 11.7287 9.2895C11.7152 9.32489 11.709 9.36262 11.7104 9.40045Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9941 19.3682C11.7987 19.3682 11.6077 19.3102 11.4452 19.2017C11.2827 19.0931 11.1561 18.9388 11.0813 18.7583C11.0065 18.5777 10.987 18.3791 11.0251 18.1874C11.0632 17.9958 11.1573 17.8197 11.2955 17.6815C11.4337 17.5434 11.6097 17.4493 11.8014 17.4111C11.993 17.373 12.1917 17.3926 12.3722 17.4674C12.5527 17.5421 12.7071 17.6688 12.8156 17.8313C12.9242 17.9937 12.9821 18.1848 12.9821 18.3802C12.9821 18.6422 12.878 18.8935 12.6927 19.0788C12.5075 19.2641 12.2562 19.3682 11.9941 19.3682Z"
        fill="currentColor"
      />
    </svg>
  ),
};
